// Auto-split from i18n.js — language: th
export default {
    translation: {
        // routes & menus
        Dashboard: 'แผงหน้าปัด',
        'Space Data': 'อวกาศ',
        'Equipment Data': 'อุปกรณ์',
        'Meter Data': 'เมตร',
        'Tenant Data': 'ผู้เช่า',
        'Store Data': 'ร้าน',
        'Shopfloor Data': 'ชั้นร้านค้า',
        'Combined Equipment Data': 'อุปกรณ์รวม',
        'Auxiliary System': 'ระบบเสริม',
        Microgrid: 'ไมโครกริด',
        'Energy Storage Power Station': 'สถานีไฟฟ้า',
        'Photovoltaic Power Station': 'สถานีไฟฟ้า',
        'Fault Alarm': 'สัญญาณเตือนความผิดพลาด',
        Monitoring: 'ตรวจ สอบ',
        'Advanced Reporting': 'การรายงานขั้นสูง',
        'Knowledge Base': 'ฐานความรู้',
        'Energy Category Data': 'ประเภทพลังงาน',
        'Energy Item Data': 'รายการพลังงาน',
        Carbon: 'การปล่อยก๊าซคาร์บอนไดออกไซด์',
        Cost: 'ค่า',
        Output: 'ผลิตภัณฑ์',
        Income: 'รายได้',
        Efficiency: 'ประสิทธิภาพ',
        Load: 'ภาระ',
        Statistics: 'สถิติ',
        'Batch Analysis': 'การวิเคราะห์แบทช์',
        Saving: 'การประหยัดⒺ',
        Plan: 'วางแผนⒺ',
        Prediction: 'PredictionⒺ',
        'Production': 'Production',
        'Space Production': 'Space Production',
        'Equipment Tracking': 'การติดตามอุปกรณ์',
        'Equipment Comparison': 'การเปรียบเทียบอุปกรณ์',
        'Shopfloor Comparison': 'การเปรียบเทียบอุปกรณ์',
        'Store Comparison': 'การเปรียบเทียบอุปกรณ์',
        'Space Comparison': 'การเปรียบเทียบอุปกรณ์',
        'Combined Equipment Comparison': 'การเปรียบเทียบอุปกรณ์',
        'Tenant Comparison': 'เปรียบเทียบผู้เช่า',
        'Environment Monitor': 'การตรวจสอบสภาพแวดล้อม',
        'Meter Energy': 'เครื่องวัดพลังงาน',
        'Meter Prediction': 'การคาดการณ์มิเตอร์Ⓔ',
        'Virtual Meter Prediction': 'การคาดการณ์มิเตอร์เสมือนⒺ',
        'Offline Meter Prediction': 'การคาดการณ์มิเตอร์ออฟไลน์Ⓔ',
        'Meter Carbon': 'มาตรวัดการปล่อย CO2',
        'Meter Cost': 'ค่ามิเตอร์',
        'Meter Trend': 'เทรนด์มิเตอร์',
        'Meter Realtime': 'มิเตอร์เรียลไทม์',
        'Meter Saving': 'ประหยัดมิเตอร์Ⓔ',
        'Meter Plan': 'แผนมิเตอร์Ⓔ',
        'Master Meter Submeters Balance': 'Master Meter Submeters สมดุล',
        'Meter Batch Analysis': 'การวิเคราะห์แบทช์มิเตอร์',
        'Meter Comparison': 'การเปรียบเทียบมิเตอร์',
        'Meter Tracking': 'การติดตามมิเตอร์',
        'Virtual Meter Saving': 'การบันทึกมิเตอร์เสมือนⒺ',
        'Virtual Meter Plan': 'แผนมิเตอร์เสมือนⒺ',
        'Virtual Meter Energy': 'เครื่องวัดพลังงานเสมือน',
        'Virtual Meter Carbon': 'เสมือนมิเตอร์ปล่อย CO2',
        'Virtual Meter Cost': 'ค่ามิเตอร์เสมือน',
        'Virtual Meter Batch Analysis': 'การวิเคราะห์แบทช์มิเตอร์เสมือน',
        'Virtual Meter Comparison': "การเปรียบเทียบมิติเสมือน",
        'Offline Meter Energy': 'เครื่องวัดพลังงานออฟไลน์',
        'Offline Meter Carbon': 'ออฟไลน์มิเตอร์ปล่อย CO2',
        'Offline Meter Cost': 'ค่ามิเตอร์ออฟไลน์',
        'Offline Meter Batch Analysis': 'การวิเคราะห์แบทช์มิเตอร์ออฟไลน์',
        'Offline Meter Saving': 'ประหยัดมิเตอร์ออฟไลน์Ⓔ',
        'Offline Meter Plan': 'แผนมิเตอร์ออฟไลน์Ⓔ',
        'Offline Meter Input': 'อินพุตมิเตอร์ออฟไลน์',
        'Tenant Bill': 'บิลผู้เช่า',
        'Energy Flow Diagram': 'แผนภาพการไหลของพลังงาน',
        'Distribution System': 'ระบบจําหน่าย',
        'SVG System': 'ระบบการแสดงภาพ SCADA',
        'Faults Data': 'ข้อ บกพร่อง',
        'Space Equipments': 'อุปกรณ์อวกาศ',
        'Combined Equipments': 'อุปกรณ์รวม',
        'Energy Storage Power Station List': 'List',
        'Energy Storage Power Station Details': 'Details',
        'Energy Storage Power Station Reporting': 'Reporting',
        'Energy Storage Power Station Alarm': 'Alarm',
        'Energy Storage Power Station Maintenance': 'Maintenance',
        'Enter Production': 'Enter Production',
        'Multiple Microgrids': 'Multiple Microgirds',
        'Multiple Microgrids Dashboard': 'Dashboard',
        'Multiple Microgrids List': 'List',
        'Single Microgrid': 'Single Microgrid',
        'Single Microgrid Dashboard': 'Dashboard',
        'Single Microgrid Details': 'Details',
        'Single Microgrid Fault Alarm': 'Fault Alarm',
        'Microgrid Reports': 'Power Station Reports',
        'Microgrid Reports Energy': 'Energy',
        'Microgrid Reports Revenue': 'Revenue',
        'Microgrid Reports Parameters': 'Parameters',
        'Multiple Energy Storage Power Stations': 'Multiple Power Stations',
        'Multiple Energy Storage Power Stations Dashboard': 'Dashboard',
        'Multiple Energy Storage Power Stations List': 'List',
        'Single Energy Storage Power Station': 'Single Power Station',
        'Single Energy Storage Power Station Dashboard': 'Dashboard',
        'Single Energy Storage Power Station Details': 'Details',
        'Single Energy Storage Power Station Fault Alarm': 'Fault Alarm',
        'Energy Storage Power Station Reports': 'Power Station Reports',
        'Energy Storage Power Station Reports Energy': 'Energy',
        'Energy Storage Power Station Reports Revenue': 'Revenue',
        'Energy Storage Power Station Reports Parameters': 'Parameters',
        'Photovoltaic Power Station List': 'Power Station List',
        'Photovoltaic Power Station Details': 'Details',
        'Photovoltaic Power Station Reporting': 'Reporting',
        'Photovoltaic Power Station Alarm': 'Alarm',
        'Photovoltaic Power Station Maintenance': 'Maintenance',
        'Multiple Photovoltaic Power Stations': 'Multiple Power Stations',
        'Multiple Photovoltaic Power Stations Dashboard': 'Dashboard',
        'Multiple Photovoltaic Power Stations List': 'List',
        'Single Photovoltaic Power Station': 'Single Power Station',
        'Single Photovoltaic Power Station Dashboard': 'Dashboard',
        'Single Photovoltaic Power Station Details': 'Details',
        'Single Photovoltaic Power Station Fault Alarm': 'Fault Alarm',
        'Photovoltaic Power Station Reports': 'Power Station Reports',
        'Photovoltaic Power Station Reports Energy': 'Energy',
        'Photovoltaic Power Station Reports Revenue': 'Revenue',
        'Photovoltaic Power Station Reports Parameters': 'Parameters',
        'Work Order': 'Work Order',
        'Work Order Installation': 'Installation',
        'Work Order Repair': ' Repair',
        'Work Order Inspection': 'Inspection',
        'Total Number of Work Orders': 'จำนวนใบสั่งงานทั้งหมด',
        'Number of New Work Orders': 'จำนวนใบสั่งงานใหม่',
        'Number of Inprogress Work Orders': 'จำนวนใบสั่งงานที่อยู่ระหว่างดำเนินการ',
        'Number of Done Work Orders': 'จำนวนใบสั่งงานที่เสร็จสิ้นแล้ว',
        'Fuel Indicator': 'อัตราการสิ้นเปลืองเชื้อเพลิง',
        'Charge Energy Indicator': 'ค่าพลังงานที่เรียกเก็บ',
        'Discharge Energy Indicator': 'ค่าพลังงานที่ปล่อยทิ้ง',
        'Charge Cost Indicator': 'ต้นทุนค่าธรรมเนียม',
        'Discharge Revenue Indicator': 'รายได้จากการปล่อยทิ้ง',
        'HVAC': 'HVAC',
        'Fire Control': 'ระบบควบคุมอัคคีภัย',
        'Store Dashboard': 'แดชบอร์ดร้านค้า',
        'Comprehensive overview of store energy performance': 'ภาพรวมประสิทธิภาพพลังงานของร้านค้า',
        'Total Stores': 'จำนวนร้านทั้งหมด',
        'Total Area': 'พื้นที่ทั้งหมด',
        'Active Meters': 'มิเตอร์ที่ใช้งาน',
        'Active Alerts': 'การแจ้งเตือนที่ใช้งาน',
        'Total Energy Consumption': 'การใช้พลังงานทั้งหมด',
        'Carbon Emissions': 'การปล่อยคาร์บอน',
        'Current Period': 'งวดปัจจุบัน',
        'Energy Consumption by Category': 'การใช้พลังงานตามหมวดหมู่',
        'Cost Distribution by Category': 'การกระจายต้นทุนตามหมวดหมู่',
        'Monthly Energy & Cost Trends': 'แนวโน้มพลังงานและต้นทุนรายเดือน',
        'Top 5 Energy Consuming Stores': 'ร้านค้าที่ใช้พลังงานสูงสุด 5 อันดับ',
        'Energy Category Details': 'รายละเอียดหมวดหมู่พลังงาน',
        'Store Performance Overview': 'ภาพรวมประสิทธิภาพร้านค้า',
        'YoY Change': 'เปลี่ยนแปลงเมื่อเทียบกับปีก่อน',
        'Per m²': 'ต่อ ตร.ม.',
        'Usage Intensity': 'ความเข้มข้นของการใช้งาน',
        'Dashboard data loaded successfully': 'โหลดข้อมูลแดชบอร์ดสำเร็จ',
        'Failed to load dashboard data': 'ไม่สามารถโหลดข้อมูลแดชบอร์ดได้',
        'Store Name': 'ชื่อร้าน',
        'Store Area': 'พื้นที่ร้าน',
        'Energy Consumption': 'การใช้พลังงาน',
        'Consumption': 'การใช้งาน',
        'last period': 'งวดก่อนหน้า',
        // Tenant Dashboard
        'Tenant Dashboard': 'แดชบอร์ดผู้เช่า',
        'Comprehensive overview of tenant energy performance': 'ภาพรวมประสิทธิภาพพลังงานของผู้เช่า',
        'Total Tenants': 'จำนวนผู้เช่าทั้งหมด',
        'Tenant Performance Overview': 'ภาพรวมประสิทธิภาพผู้เช่า',
        'Tenant Name': 'ชื่อผู้เช่า',
        'Tenant Area': 'พื้นที่ผู้เช่า',
        'Tenant Type': 'ประเภทผู้เช่า',
        // Equipment Dashboard
        'Equipment Dashboard': 'แดชบอร์ดอุปกรณ์',
        'Total Equipments': 'จำนวนอุปกรณ์ทั้งหมด',
        'Equipment Performance Overview': 'ภาพรวมประสิทธิภาพอุปกรณ์',
        'Equipment Name': 'ชื่ออุปกรณ์',
        'Equipment Type': 'ประเภทอุปกรณ์',
        'Total Energy': 'พลังงานรวม',
        'Total Sensors': 'จำนวนเซ็นเซอร์ทั้งหมด',
        'Increment Rate': 'อัตราการเพิ่มขึ้น',
        // Shopfloor Dashboard
        'Total Shopfloors': 'จำนวนโรงงานทั้งหมด',
        'Shopfloor Performance Overview': 'ภาพรวมประสิทธิภาพโรงงาน',
        'Shopfloor Name': 'ชื่อโรงงาน',
        'Shopfloor Area': 'พื้นที่โรงงาน',
        // Combined Equipment Dashboard
        'Total Combined Equipments': 'จำนวนอุปกรณ์รวมทั้งหมด',
        'Combined Equipment Performance Overview': 'ภาพรวมประสิทธิภาพอุปกรณ์รวม',
        'Combined Equipment Name': 'ชื่ออุปกรณ์รวม',
        'Associated Equipments': 'อุปกรณ์ที่เกี่ยวข้อง',


            // Dashboard
            'Welcome to QiXuan': 'ยินดีต้อนรับสู่ QiXuan',
            'An Industry Leading Energy Management System': 'ระบบการจัดการพลังงานชั้นนําของอุตสาหกรรม',
            "This Year's Consumption CATEGORY VALUE UNIT": 'การบริโภคในปีนี้ {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Year's Costs CATEGORY VALUE UNIT": 'ค่าใช้จ่ายในปีนี้ {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Month's Consumption CATEGORY VALUE UNIT": 'การบริโภคในเดือนนี้ {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Month's Generation CATEGORY VALUE UNIT": "This Month's Generation {{CATEGORY}} {{VALUE}} {{UNIT}}",
            "This Month's Costs CATEGORY VALUE UNIT": 'ค่าใช้จ่ายของเดือนนี้ {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Consumption CATEGORY VALUE UNIT in The Same Period Last Year':
                'การบริโภค {{CATEGORY}} {{VALUE}} {{UNIT}} ในช่วงเดียวกันของปีก่อน',
            'Costs CATEGORY VALUE UNIT in The Same Period Last Year':
                'ต้น ทุน {{CATEGORY}} {{VALUE}} {{UNIT}} ในช่วงเดียวกันของปีก่อน',
            'CATEGORY Consumption UNIT': '{{CATEGORY}} การบริโภค {{UNIT}}',
            'CATEGORY Costs UNIT': '{{CATEGORY}} ต้น ทุน {{UNIT}}',
            // Entities
            Space: 'อวกาศ',
            Equipment: 'อุปกรณ์',
            Meter: 'เมตร',
            'Offline Meter': 'เครื่องวัดออฟไลน์',
            'Virtual Meter': 'เครื่องวัดเสมือน',
            Tenant: 'ผู้เช่า',
            Store: 'ร้าน',
            Shopfloor: 'ชั้นร้านค้า',
            'Combined Equipment': 'อุปกรณ์รวม',
            'Cost Center': 'ศูนย์ต้นทุน',
            Name: 'ชื่อ',
            DisplayName: 'ชื่อที่ใช้แสดง',
            UserName: 'ชื่อผู้ใช้',
            Description: 'การบรรยาย',
            'Energy Category': 'ประเภทพลังงาน',
            'Child Spaces': 'พื้นที่สําหรับเด็ก',
            'Associated Equipment': 'อุปกรณ์ที่เกี่ยวข้อง',
            //Energy Categories
            Electricity: 'ไฟฟ้า',
            Water: 'น้ำ',
            'Natural Gas': 'ก๊าซธรรมชาติ',
            // SidePanelModal
            Settings: 'การตั้งค่า',
            'Set your own customized style': 'กําหนดสไตล์ของคุณเอง',
            'Color Scheme': 'โทนสี',
            'Choose the perfect color mode for your app': 'เลือกโหมดสีที่สมบูรณ์แบบสําหรับแอปของคุณ',
            Light: 'แสง',
            Dark: 'มืด',
            'RTL Mode': 'โหมด RTL',
            'Switch your language direction': 'เปลี่ยนทิศทางภาษาของคุณ',
            'Fluid Layout': 'เค้าโครงของไหล',
            'Toggle container layout system': 'สลับระบบเค้าโครงคอนเทนเนอร์',
            'Navigation Position': 'ตําแหน่งการนําทาง',
            'Vertical': 'แนวตั้ง',
            'Top': 'ด้านบน',
            'Combo': 'คอมโบ',
            'Transparent': 'โปร่งใส',
            'Inverted': 'กลับด้าน',
            'Card': 'การ์ด',
            'Vibrant': 'สดใส',
            'Select a suitable navigation system for your web application':
                'เลือกระบบนําทางที่เหมาะสมสําหรับเว็บแอปพลิเคชันของคุณ',
            'Vertical Nav': 'การนําทางแนวตั้ง',
            'Top Nav': 'มูลค่านําเที่ยวสูงสุด',
            'Vertical Navbar Style': 'แนวตั้ง Navbar Style',
            'Switch between styles for your vertical navbar': 'สลับระหว่างสไตล์สําหรับ navbar แนวตั้งของคุณ',
            Language: 'ภาษา',
            'Switch between languages': 'สลับระหว่างภาษาต่างๆ',
            'language-zh_CN': '简体中文',
            'language-en': 'English',
            'language-de': 'Deutsch',
            'language-fr': 'Français',
            'language-es': 'Español',
            'language-ru': 'Русский',
            'language-ar': 'العربية',
            'language-vi': 'Tiếng Việt',
            'language-th': 'ภาษาไทย',
            'language-tr': 'Türkçe',
            'language-ms': 'Bahasa Melayu',
            'language-id': 'Bahasa Indonesia',
            'language-zh_TW': '繁體中文',
            'language-pt': 'Português',
            'language-ko_KR': '로그아웃',
            'language-it': 'Italiano',
            'language-pol': 'Polski',
            'language-nl': 'Nederlands',
            'language-jp': '日本語',
            'language-fa': 'فارسی',
            'Like What You See?': 'ชอบสิ่งที่คุณเห็น?',
            'Get QiXuan now': 'รับ QiXuan ทันที',
            Purchase: 'รุ่นองค์กร',
            ContactInfo: 'ข้อมูลติดต่อ',
            ProductWebsite: 'เว็บไซต์ผลิตภัณฑ์',
            CompanyWebsite: 'เว็บไซต์บริษัท',
            SalesPhone: 'โทรศัพท์ฝ่ายขาย',
            // Query Panel
            'Base Period Begins': 'ระยะเวลาฐานเริ่มต้น',
            'Base Period Ends': 'ระยะเวลาฐานเริ่มต้น',
            'Comparison Types': 'ประเภทการเปรียบเทียบ',
            'Year-Over-Year': 'ปีต่อปี',
            'Month-On-Month': 'เดือนต่อเดือน',
            'Free Comparison': 'เปรียบเทียบฟรี',
            'None Comparison': 'ไม่มีการเปรียบเทียบ',
            'Reporting Period Begins': 'รอบระยะเวลารายงานเริ่มต้น',
            'Reporting Period Ends': 'สิ้นสุดรอบระยะเวลารายงาน',
            '(Optional)': '(เสริม)',
            'Period Types': 'ประเภทระยะเวลา',
            Yearly: 'รายปี',
            Monthly: 'รายเดือน',
            Weekly: 'รายสัปดาห์',
            Daily: 'ทุกวัน',
            Hourly: 'รายชั่วโมง',
            Submit: 'ส่ง',
            'Input Energy Category': 'ประเภทพลังงานอินพุต',
            'Output Energy Category': 'ประเภทพลังงานขาออก',
            'Fraction Parameter': 'พารามิเตอร์เศษส่วน',
            Search: 'ค้น',
            //DateRangePicker
            sunday: 'ซู',
            monday: 'โม',
            tuesday: 'ตู่',
            wednesday: 'เรา',
            thursday: 'สธ.',
            friday: 'FR',
            saturday: 'ซา',
            ok: 'ตกลง, ได้',
            today: 'วันนี้',
            yesterday: 'เมื่อวานนี้',
            hours: 'ชั่วโมง',
            minutes: 'รายงานการประชุม',
            seconds: 'วินาที',
            last7Days: '7 วันที่ผ่านมา',
            tomorrow: 'พรุ่งนี้',
            dayAfterTomorrow: 'มะรืน',
            next7Days: '7 วันข้างหน้า',
            'Select Date Range': 'เลือกช่วงวันที่',
            //Card Summaries and Line Charts
            'Base Period': 'ระยะเวลาฐาน',
            'Reporting Period': 'รอบระยะเวลารายงาน',
            'Per Unit Area': 'ต่อหน่วยพื้นที่',
            'Per Capita': 'Per Capita',
            'Per Unit Production': 'ต่อหน่วยการผลิต',
            Baseline: 'พื้นฐาน',
            Actual: 'จริง',
            'Baseline Value - Actual Value': 'พื้นฐาน - จริง',
            'Average Load': 'โหลดเฉลี่ย',
            'Maximum Load': 'โหลดสูงสุด',
            'Load Factor': 'โหลดแฟกเตอร์',
            'Ratio of Average Load to Maximum Load': 'อัตราส่วนของโหลดเฉลี่ยต่อโหลดสูงสุด',
            'Carbon Dioxide Emissions by Energy Category': 'การปล่อยก๊าซคาร์บอนไดออกไซด์ตามประเภทพลังงาน',
            'Costs by Energy Category': 'ค่าใช้จ่ายตามหมวดพลังงาน',
            'Incomes by Energy Category': 'รายได้ตามหมวดพลังงาน',
            'Electricity Consumption by Time-Of-Use': 'ปริมาณการใช้ไฟฟ้าตามเวลาการใช้งาน',
            'Electricity Carbon Dioxide Emissions by Time-Of-Use': 'การปล่อยก๊าซคาร์บอนไดออกไซด์จากไฟฟ้าตามเวลาการใช้งาน',
            'Electricity Cost by Time-Of-Use': 'ค่าไฟฟ้าตามเวลาที่ใช้',
            'CATEGORY UNIT Consumption by Energy Items': '{{CATEGORY}} {{UNIT}} Comsumption โดยรายการพลังงาน',
            'Ton of Standard Coal by Energy Category': 'ตันของถ่านหินมาตรฐาน (TCE) ตามประเภทพลังงาน',
            'Ton of Carbon Dioxide Emissions by Energy Category':
                'ตันของการปล่อยก๊าซคาร์บอนไดออกไซด์ (TCO2E) ตามประเภทพลังงาน',
            'Reporting Period Consumption CATEGORY UNIT': 'ปริมาณการใช้ในรอบระยะเวลารายงาน {{CATEGORY}} {{UNIT}}',
            'Reporting Period Prediction CATEGORY UNIT': 'Reporting Period Prediction {{CATEGORY}} {{UNIT}}',
            'EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
                '{{EQUIPMENT}} ปริมาณการใช้ในรอบระยะเวลารายงาน {{CATEGORY}} {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
                '{{COMBINED_EQUIPMENT}} ปริมาณการใช้ในรอบระยะเวลารายงาน {{CATEGORY}} {{UNIT}}',
            'CATEGORY VALUE UNIT': '{{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Consumption CATEGORY VALUE UNIT': 'ปริมาณการใช้ในรอบระยะเวลารายงาน {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Prediction CATEGORY VALUE UNIT': 'Reporting Period Prediction {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Production PRODUCT VALUE UNIT': 'Reporting Period Production {{PRODUCT}} {{VALUE}} {{UNIT}}',
            'Base Period Production PRODUCT VALUE UNIT': 'Base Period Production {{PRODUCT}} {{VALUE}} {{UNIT}}',
            'Base Period Consumption CATEGORY VALUE UNIT': 'การบริโภคช่วงฐาน {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Prediction CATEGORY VALUE UNIT': 'Base Period Prediction {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Consumption ITEM CATEGORY UNIT':
                'ปริมาณการใช้ในรอบระยะเวลารายงาน {{ITEM}} {{CATEGORY}} {{UNIT}}',
            'Reporting Period Consumption ITEM CATEGORY VALUE UNIT':
                'ปริมาณการใช้ในรอบระยะเวลารายงาน {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Consumption ITEM CATEGORY VALUE UNIT': 'การบริโภคช่วงฐาน {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Child Space Proportion CATEGORY UNIT': 'สัดส่วนพื้นที่เด็กแบ่งตามประเภทพลังงาน {{CATEGORY}} {{UNIT}}',
            'Child Space Total Proportion': 'พื้นที่เด็กสัดส่วนทั้งหมด',
            'Reporting Period Carbon Dioxide Emissions CATEGORY UNIT':
                'รอบระยะเวลารายงานการปล่อยก๊าซคาร์บอนไดออกไซด์ {{CATEGORY}} {{UNIT}}',
            'Reporting Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
                'รอบระยะเวลารายงานการปล่อยก๊าซคาร์บอนไดออกไซด์ {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
                'การปล่อยก๊าซคาร์บอนไดออกไซด์ในช่วงเวลาพื้นฐาน {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Costs CATEGORY UNIT': 'ค่าใช้จ่ายรอบระยะเวลารายงาน {{CATEGORY}} {{UNIT}}',
            'Reporting Period Costs CATEGORY VALUE UNIT': 'ค่าใช้จ่ายรอบระยะเวลารายงาน {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Costs CATEGORY VALUE UNIT': 'ค่าใช้จ่ายรอบระยะเวลาพื้นฐาน {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Output CATEGORY UNIT': 'ผลผลิตรอบระยะเวลารายงาน {{CATEGORY}} {{UNIT}}',
            'EQUIPMENT Reporting Period Output CATEGORY UNIT': '{{EQUIPMENT}} ผลผลิตรอบระยะเวลารายงาน {{CATEGORY}} {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Output CATEGORY UNIT':
                '{{COMBINED_EQUIPMENT}} ผลผลิตรอบระยะเวลารายงาน {{CATEGORY}} {{UNIT}}',
            'Reporting Period Output CATEGORY VALUE UNIT': 'ผลผลิตรอบระยะเวลารายงาน {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Output CATEGORY VALUE UNIT': 'เอาต์พุตระยะเวลาฐาน {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Income CATEGORY UNIT': 'รายได้รอบระยะเวลารายงาน {{CATEGORY}} {{UNIT}}',
            'Reporting Period Income CATEGORY VALUE UNIT': 'รายได้รอบระยะเวลารายงาน {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Income CATEGORY VALUE UNIT': 'รายได้งวดฐาน {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Total Income UNIT': 'รอบระยะเวลารายงาน รายได้รวม {{UNIT}}',
            'Reporting Period Cumulative Efficiency NAME UNIT': 'รอบระยะเวลารายงาน ประสิทธิภาพสะสม {{NAME}} {{UNIT}}',
            'EQUIPMENT Reporting Period Cumulative Efficiency UNIT':
                '{{EQUIPMENT}} รอบระยะเวลารายงาน ประสิทธิภาพสะสม {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency UNIT':
                '{{COMBINED_EQUIPMENT}} รอบระยะเวลารายงาน ประสิทธิภาพที่ครอบคลุมสะสม {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency VALUE UNIT':
                '{{COMBINED_EQUIPMENT}} รอบระยะเวลารายงาน ประสิทธิภาพที่ครอบคลุมสะสม {{VALUE}} {{UNIT}}',
            'COMBINED_EQUIPMENT Base Period Cumulative Comprehensive Efficiency VALUE UNIT':
                '{{COMBINED_EQUIPMENT}} ระยะเวลาฐานประสิทธิภาพที่ครอบคลุมสะสม {{VALUE}} {{UNIT}}',
            'Instantaneous Efficiency UNIT': 'ประสิทธิภาพทันที {{UNIT}}',
            'EQUIPMENT Instantaneous Efficiency UNIT': '{{EQUIPMENT}} ประสิทธิภาพทันที {{UNIT}}',
            'Equipment Efficiency Indicator': 'ตัวชี้วัดประสิทธิภาพพลังงานของอุปกรณ์',
            'COMBINED_EQUIPMENT Instantaneous Comprehensive Efficiency UNIT':
                '{{COMBINED_EQUIPMENT}} ประสิทธิภาพที่ครอบคลุมทันที {{UNIT}}',
            'Reporting Period Cumulative Efficiency VALUE UNIT': 'รอบระยะเวลารายงาน ประสิทธิภาพสะสม {{VALUE}} {{UNIT}}',
            'Reporting Period Cumulative Efficiency NAME VALUE UNIT':
                'รอบระยะเวลารายงาน ประสิทธิภาพสะสม {{NAME}} {{VALUE}} {{UNIT}}',
            'Base Period Cumulative Efficiency VALUE UNIT': 'ประสิทธิภาพการสะสมของระยะเวลาฐาน {{VALUE}} {{UNIT}}',
            'Base Period Cumulative Efficiency NAME VALUE UNIT':
                'ประสิทธิภาพการสะสมของระยะเวลาฐาน {{NAME}} {{VALUE}} {{UNIT}}',
            'Base Period CATEGORY Maximum Load UNIT': 'ระยะเวลาฐาน {{CATEGORY}} โหลดสูงสุด {{UNIT}}',
            'Reporting Period CATEGORY Maximum Load UNIT': 'รอบระยะเวลารายงาน {{CATEGORY}} โหลดสูงสุด {{UNIT}}',
            'Reporting Period CATEGORY Average Load UNIT': 'รอบระยะเวลารายงาน {{CATEGORY}} โหลดเฉลี่ย {{UNIT}}',
            'Reporting Period CATEGORY Load Factor': 'รอบระยะเวลารายงาน {{CATEGORY}} โหลดแฟกเตอร์',
            'Base Period CATEGORY Average Load VALUE UNIT': 'ระยะเวลาฐาน {{CATEGORY}} โหลดเฉลี่ย {{VALUE}} {{UNIT}}',
            'Reporting Period CATEGORY Average UNIT': 'รอบระยะเวลารายงาน {{CATEGORY}} ค่าเฉลี่ย {{UNIT}}',
            'Reporting Period CATEGORY Maximum UNIT': 'รอบระยะเวลารายงาน {{CATEGORY}} ค่าสูงสุด {{UNIT}}',
            'Reporting Period CATEGORY Minimum UNIT': 'รอบระยะเวลารายงาน {{CATEGORY}} มูลค่าขั้นต่ํา {{UNIT}}',
            'Reporting Period CATEGORY Mean UNIT': 'รอบระยะเวลารายงาน {{CATEGORY}} ค่าเฉลี่ยเลขคณิต {{UNIT}}',
            'Reporting Period CATEGORY Median UNIT': 'รอบระยะเวลารายงาน {{CATEGORY}} ค่ามัธยฐาน (ค่ากลาง) {{UNIT}}',
            'Reporting Period CATEGORY Stdev UNIT': 'รอบระยะเวลารายงาน {{CATEGORY}} ตัวอย่างค่าเบี่ยงเบนมาตรฐาน {{UNIT}}',
            'Reporting Period CATEGORY Variance UNIT': 'รอบระยะเวลารายงาน {{CATEGORY}} ความแปรปรวนของตัวอย่าง {{UNIT}}',
            'Reporting Period Saving CATEGORY (Baseline - Actual) UNIT':
                'การบันทึกรอบระยะเวลารายงาน {{CATEGORY}} (พื้นฐาน - จริง) {{UNIT}}',
            'Reporting Period Decreased CATEGORY (Baseline - Actual) UNIT':
                'รอบระยะเวลารายงานลดลง {{CATEGORY}} (พื้นฐาน - จริง) {{UNIT}}',
            'Reporting Period Saving CATEGORY VALUE UNIT': 'การบันทึกรอบระยะเวลารายงาน {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Saving CATEGORY VALUE UNIT': 'การออมระยะเวลาพื้นฐาน {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Master Meter Consumption CATEGORY UNIT':
                'ระยะเวลาการรายงานการใช้มิเตอร์หลัก {{CATEGORY}} {{UNIT}}',
            'Reporting Period Master Meter Consumption CATEGORY VALUE UNIT':
                'ระยะเวลาการรายงานการใช้มิเตอร์หลัก {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Submeters Consumption CATEGORY UNIT':
                'ระยะเวลาการรายงาน Submeters การบริโภค {{CATEGORY}} {{UNIT}}',
            'Reporting Period Submeters Consumption CATEGORY VALUE UNIT':
                'ระยะเวลาการรายงาน Submeters การบริโภค {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Difference CATEGORY UNIT': 'ความแตกต่างของรอบระยะเวลารายงาน {{CATEGORY}} {{UNIT}}',
            'Reporting Period Percentage Difference': 'ความแตกต่างของเปอร์เซ็นต์รอบระยะเวลารายงาน',
            'Reporting Period Difference CATEGORY VALUE UNIT':
                'ความแตกต่างของรอบระยะเวลารายงาน {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Trend Values': 'ค่าแนวโน้ม',
            'METER CATEGORY VALUE UNIT': '{{METER}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'EQUIPMENT CATEGORY VALUE UNIT': '{{EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'COMBINED_EQUIPMENT CATEGORY VALUE UNIT': '{{COMBINED_EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'SHOPFLOOR CATEGORY VALUE UNIT': '{{SHOPFLOOR}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'TENANT CATEGORY VALUE UNIT': '{{TENANT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            //FDD
            'Fault List': 'รายการข้อบกพร่อง',
            'Reporting Period Number of Fault VALUE': 'จํานวนรอบระยะเวลารายงานความผิดพลาด {{VALUE}}',
            'All Faults': 'ความผิดพลาดทั้งหมด',
            'Space Faults': 'ความผิดพลาดของพื้นที่',
            'Number of All Faults': 'จํานวนความผิดพลาดทั้งหมด',
            'Number of Space Faults': 'จํานวนความผิดพลาดของพื้นที่',
            'Total Number of Faults': 'Total Number of Faults',
            'Number of New Faults': 'Number of New Faults',
            'Number of Inprogress Faults': 'Number of Inprogress Faults',
            'Number of Done Faults': 'Number of Done Faults',
            //Data Panels
            'Ton of Standard Coal': 'ตันของถ่านหินมาตรฐาน',
            'Ton of Carbon Dioxide Emissions': 'ตันของการปล่อยก๊าซคาร์บอนไดออกไซด์',
            'Carbon Emissions Per Unit Of Energy Consumption': 'การปล่อยคาร์บอนต่อหน่วยการบริโภคพลังงาน',
            'Operating Characteristic Curve': 'เส้นโค้งลักษณะการทำงาน',
            Tariff: 'ภาษี',
            'Detailed Data': 'ข้อมูลรายละเอียด',
            'Child Spaces Data': 'ข้อมูลพื้นที่ย่อย',
            'Associated Equipment Data': 'ข้อมูลอุปกรณ์ที่เกี่ยวข้อง',
            'This Year': 'ในปีนี้',
            'The Same Period Last Year': 'ช่วงเดียวกันของปีก่อน',
            'This Month': 'เดือนนี้',
            'This Day': 'วันนี้',
            Total: 'ทั้งหมด',
            'No data found': 'ไม่พบข้อมูล',
            Export: 'ส่งออก',
            'AI Analysis': 'การวิเคราะห์ AI',
            Datetime: 'วันที่เวลา',
            'Time-Of-Use Type': 'ประเภทเวลาใช้งาน',
            'Top-Peak': 'ท็อปพีค',
            'On-Peak': 'ออนพีค',
            'Mid-Peak': 'มิดพีค',
            'Off-Peak': 'ออฟพีค',
            'Deep': 'Deep-Valley',
            Percentage: 'อัตราร้อยละ',
            //Realtime Chart
            'Trend in the last hour of Energy Value Point': 'แนวโน้มในชั่วโมงสุดท้ายของ Energy Value Point',
            Circuit: 'วงจร',
            Point: 'จุด',
            'Realtime Value': 'มูลค่าเรียลไทม์',
            //Meter Tracking
            'Meter List': 'รายการมิเตอร์',
            'Edit Meter': 'แก้ไข',
            'Start Value': 'มูลค่าเริ่มต้น',
            'End Value': 'มูลค่าสิ้นสุด',
            'Difference Value': 'ค่าความแตกต่าง',
            'Start Integrity Rate': 'เริ่ม Integrity Rate(%)',
            'End Integrity Rate': 'สิ้นสุดอัตราความสมบูรณ์(%)',
            'Full Integrity Rate': 'อัตราความซื่อสัตย์เต็มที่(%)',
            'Start Integrity Rate Description': 'อัตราความสมบูรณ์ของข้อมูลเริ่มต้น: สัดส่วนของมิเตอร์ทั้งหมดที่ได้รับค่าอ่านการใช้พลังงานในช่วงเวลาเริ่มต้นสำเร็จในช่วงเวลาสถิติ',
            'End Integrity Rate Description': 'อัตราความสมบูรณ์ของข้อมูลสุดท้าย: สัดส่วนของมิเตอร์ทั้งหมดที่ได้รับค่าอ่านการใช้พลังงานในช่วงเวลาสุดท้ายสำเร็จในช่วงเวลาสถิติ',
            'Full Integrity Rate Description': 'อัตราความสมบูรณ์ของข้อมูลทั้งหมด: สัดส่วนของมิเตอร์ทั้งหมดที่ได้รับค่าอ่านการใช้พลังงานในช่วงเวลาเริ่มต้นและสุดท้ายสำเร็จในช่วงเวลาสถิติ',
            //Equipment Tracking
            'Equipment List': 'รายการอุปกรณ์',
            'Edit Equipment': 'แก้ไข',
            //Profile Dropdown
            Feedback: 'การตอบสนอง',
            'Account Settings': 'การตั้งค่าบัญชี',
            Logout: 'ออกจากระบบ',
            //Authentication
            'Log in': 'เข้าสู่ระบบ',
            'Email address': 'ที่อยู่อีเมล',
            'Phone Number': 'หมายเลขโทรศัพท์',
            Password: 'รหัสผ่าน',
            CaptchaCode: 'แคปต์ชา',
            Refresh: 'ฟื้นฟู',
            'Remember me': 'จําฉันไว้',
            'Logged in as ': 'เข้าสู่ระบบเป็น ',
            'Forgot Password?': 'ลืมรหัสผ่าน?',
            'Forgot your password?': 'ลืมรหัสผ่าน?',
            "Enter your email and we'll send you a reset link": 'ป้อนอีเมลของคุณแล้วเราจะส่งลิงก์รีเซ็ตให้คุณ',
            "Enter your email and we'll send you a registration link": 'ป้อนอีเมลของคุณแล้วเราจะส่งลิงก์ลงทะเบียนให้คุณ',
            'Reset Password': 'รีเซ็ตรหัสผ่าน',
            'Thanks for using QiXuan!': 'ขอบคุณที่ใช้ QiXuan!',
            'You are now successfully signed out': 'ตอนนี้คุณออกจากระบบเรียบร้อยแล้ว',
            'Return to Login': 'กลับไปที่เข้าสู่ระบบ',
            'Please check your email!': 'โปรดตรวจสอบอีเมลของคุณ!',
            'An email has been sent to ': 'อีเมลถูกส่งไปยัง ',
            'Please click on the included link to reset your password': 'โปรดคลิกที่ลิงค์ที่ให้มาเพื่อรีเซ็ตรหัสผ่านของคุณ',
            'Please click on the included link to register your account': 'โปรดคลิกที่ลิงค์ที่ให้มาเพื่อลงทะเบียนบัญชีของคุณ',
            'An email with password reset link is sent to ': 'อีเมลที่มีลิงก์รีเซ็ตรหัสผ่านจะถูกส่งไปยัง ',
            'Change Password': 'เปลี่ยนรหัสผ่าน',
            'Old Password': 'รหัสผ่านเก่า',
            'New Password': 'รหัสผ่านใหม่',
            'Confirm Password': 'ยืนยันรหัสผ่าน',
            'Update Password': 'อัปเดตรหัสผ่าน',
            'Password has been changed!': 'เปลี่ยนรหัสผ่านแล้ว!',
            'Verification code has been sent to your inbox. \
      Please copy it to the input box below..':
                'รหัสยืนยันถูกส่งไปยังกล่องจดหมายของคุณแล้ว. \
      โปรดคัดลอกไปยังช่องป้อนข้อมูลด้านล่าง.',
            'New to QiXuan': 'เพิ่งเริ่มใช้ QiXuan',
            'Create an account': 'สร้างบัญชี',
            'EMAIL Account registration successful': '{{EMAIL}} การลงทะเบียนบัญชีสําเร็จ',
            'Thanks for verifying your account!': 'ขอบคุณสําหรับการยืนยันบัญชีของคุณ!',
            'Your code is': 'รหัสของคุณคือ',
            'Send verification code': 'ส่งรหัสยืนยัน',
            'Please wait for NUMBER seconds': 'กรุณารอสักครู่ {{NUMBER}} วินาที',
            'Password reset': 'รีเซ็ตรหัสผ่าน',
            'Please wait for approval': 'กรุณารอการอนุมัติ',
            //notification
            Notifications: 'แจ้ง เตือน',
            'Mark all as read': 'ทําเครื่องหมายทั้งหมดว่าอ่านแล้ว',
            'View all': 'ทั้งหมด',
            'Notification New': 'ใหม่',
            'Notification Earlier': 'เมื่อก่อน',
            'Notification List': 'รายการการแจ้งเตือน',
            'Bulk actions': 'การดําเนินการหลายรายการในครั้งเดียว',
            'Notification Subject': 'ชื่อเรื่อง',
            'Notification Created Datetime': 'วันที่และเวลาที่สร้าง',
            'Notification Priority': 'สำคัญ',
            'Notification Message': 'ข้อความ',
            'Notification Status': 'สถานะ',
            'Notification Mark As Read': 'ทําเครื่องหมายว่าอ่านแล้ว',
            'Notification Mark As Acknowledged': 'ยอมรับ',
            'Notification Low': 'ต่ํา',
            'Notification Medium': 'ปานกลาง',
            'Notification High': 'สูง',
            'Notification Critical': 'เกี่ยวกับการวิจารณ์',
            'Notification Unread': 'ยังไม่ได้อ่าน',
            'Notification Read': 'อ่าน',
            'Notification Acknowledged': 'ยอม รับ',
            'Notification Archive': 'หอจดหมายเหตุ',
            'Notification Delete': 'ลบ',
            'Notification Apply': 'ใช้',
            'Notification Start Datetime': 'เริ่มวันที่และเวลา',
            'Notification End Datetime': 'สิ้นสุดวันที่และเวลา',
            'Notification Update Datetime': 'อัปเดตวันที่และเวลา',
            //Monitoring
            'Run Commands': 'เรียกใช้คําสั่ง',
            'Pin Code': 'รหัสพิน',
            'Unlock': 'ปลดล็อค',
            'Set Value': 'ตั้งค่าค่า',
            'Fault Alarms': 'สัญญาณเตือนความผิดพลาด',
            'Instantaneous Efficiency VALUE UNIT': 'ประสิทธิภาพทันที {{VALUE}} {{UNIT}}',
            'Communication Online': 'ออนไลน์',
            'Communication Offline': 'ออฟไลน์',
            'Equipment Status': 'สถานะของอุปกรณ์',
            'Equipment Running': 'กำลัง เรียก ใช้',
            'Equipment Stopped': 'หยุด',
            'Show Up to': 'แสดงถึง',
            All: 'ทั้งหมด',
            'FROM - TO of TOTAL': '{{FROM}} - {{TO}} ของ {{TOTAL}} อุปกรณ์',
            //Microgrid
            'Microgrid Energy': 'พลังงานไมโครกริด',
            'Microgrid Revenue': 'รายได้จากไมโครกริด',
            'Microgrid Carbon': 'คาร์บอนจากไมโครกริด',
            'Photovoltaic Generation': 'การผลิตไฟฟ้าพลังงานแสงอาทิตย์',
            'EV Charger Consumption': 'การใช้พลังงานของเครื่องชาร์จรถยนต์ไฟฟ้า',
            'Load Consumption': 'การใช้พลังงานโหลด',
            'Grid Buy': 'การซื้อจากกริด',
            'Grid Sell': 'การขายให้กริด',
            'EV Charger': 'เครื่องชาร์จรถยนต์ไฟฟ้า',
            'Heat Pump': 'ปั๊มความร้อน',
            'Photovoltaic': 'โฟโตวอลตาอิก',
            'PCS Run State': 'PCS สถานะการทำงาน',
            'PCS Unknown': 'ไม่ทราบ',
            'PCS Initializing': 'กำลังเริ่มต้น',
            'PCS Standby': 'รายการสำรอง',
            'PCS Shutdown': 'ปิดเครื่อง',
            'PCS Fault': 'ความผิด',
            'PCS Running': 'วิ่ง',
            'Battery Power': 'พลังงานแบตเตอรี่',
            'Photovoltaic Power': 'Fotovoltaik gücü',
            'Grid Power': 'พลังงานกริด',
            'Load Power': 'กำลังโหลด',
            Reporting: 'รายงาน',
            Maintenance: 'การซ่อมแซม',
            'Serial Number': 'หมายเลขผลิตภัณฑ์',
            Address: 'ที่อยู่',
            'Postal Code': 'รหัสไปรษณีย์',
            'Rated Capacity': 'ความจุสูงสุด',
            'Rated Power': 'กำลังไฟสูงสุด',
            Latitude: 'ละติจูด',
            Longitude: 'ลองจิจูด',
            'Strategy Management': 'การจัดการนโยบาย',
            'Charging Schedule': 'กำหนดการชาร์จ',
            'Charge Start Time': 'เวลาเริ่มต้นการชาร์จ',
            'Charge End Time': 'เวลาสิ้นสุดการชาร์จ',
            'Discharge Start Time': 'เวลาเริ่มต้นของการปลดปล่อย',
            'Discharge End Time': 'เวลาสิ้นสุดการปลดปล่อย',
            'Total Rated Power': 'กำลังไฟรวม',
            'Total Rated Capacity': 'ความจุสูงสุดรวม',
            "Today's Charge": "จำนวนเงินที่เรียกเก็บวันนี้",
            "Today's Discharge": "ปลดประจำการวันนี้",
            "Today's Generation": "การผลิตกระแสไฟฟ้าในปัจจุบัน",
            'Total Fuel Consumption': 'Total Fuel Consumption',
            'Total Charge': 'ค่าใช้จ่ายทั้งหมด',
            'Total Discharge': 'การปลดปล่อยทั้งหมด',
            'Total Generation': 'รุ่นทั้งหมด',
            'Total Revenue': 'รายได้รวม',
            'Total Photovoltaic Generation': 'การผลิตไฟฟ้าพลังงานแสงอาทิตย์ทั้งหมด',
            'Total EV Charger Consumption': 'การใช้พลังงานชาร์จ EV ทั้งหมด',
            'Total Load Consumption': 'การใช้พลังงานโหลดทั้งหมด',
            'Total Grid Buy': 'การซื้อจากกริดทั้งหมด',
            'Total Grid Sell': 'การขายให้กริดทั้งหมด',
            'Total Efficiency': 'ประสิทธิภาพโดยรวม',
            'Discharge Achievement Rate': 'อัตราความสำเร็จในการระบาย',
            // Revenue Indicator
            "Today's Cost": "Today's Cost",
            "Today's Income": "Today's Income",
            "Total Cost": "Total Cost",
            "Total Income": "Total Income",
            "Today's Revenue": "Today's Revenue",

            'Revenue Ranking': 'การจัดอันดับรายได้',
            'Efficiency Ranking': 'การจัดอันดับประสิทธิภาพ',
            'Charge Ranking': 'การจัดอันดับความจุการชาร์จ',
            'Discharge Ranking': 'อันดับการปลดปล่อย',
            'Number of Microgrids': 'จำนวนไมโครกริด',
            'Number of Power Stations': 'จำนวนสถานีไฟฟ้า',
            'Microgrid List': 'รายการไมโครกริด',
            'Select Microgrid': 'เลือกไมโครกริด',
            'Previous Page': 'หน้าก่อนหน้า',
            'Next Page': 'หน้าต่อไป',
            '7 Days': '7 วัน',
            'Charge UNIT': 'ค่าใช้จ่าย {{UNIT}}',
            'Discharge UNIT': 'ปล่อย {{UNIT}}',
            'Generation UNIT': 'ผลิตกระแสไฟฟ้า {{UNIT}}',
            'Energy Indicator': 'ดัชนีพลังงาน',
            'Revenue Indicator': 'ตัวบ่งชี้ผลผลิต',
            'Carbon Indicator': 'ดัชนีคาร์บอน',

            // Energy Storage Power Station
            'Battery Operating State': 'สถานะการทำงานของแบตเตอรี่',
            'Battery State': 'สถานะแบตเตอรี่',
            'Battery Unknown': 'ไม่ทราบ',
            'Battery Stopped': 'หยุดแล้ว',
            'Battery Reserved': 'Reserved', // 0
            'Battery Fault': 'ความผิด', // 1
            'Battery Warning': 'คำเตือน', // 2
            'Battery Standby': 'รายการสำรอง', // 3
            'Battery Prohibit DisCharging': 'ห้ามขนถ่าย', // 4
            'Battery Prohibit Charging': 'ห้ามชาร์จ', // 5
            'Battery Normal': 'ทั่วไป', // 6
            'Battery Charging': 'ในการชาร์จ', // 7
            'Battery Discharging': 'ในการปลดปล่อย', // 8
            'Battery Idle': 'Idle', // 9
            'Phase of Lifecycle': 'ระยะวงจรชีวิต',
            'Use Phase': 'ขั้นตอนการใช้งาน',
            'Commissioning Phase': 'ขั้นตอนการว่าจ้าง',
            'Commissioning Date': 'Commissioning Date',
            'Installation Phase': 'ขั้นตอนการติดตั้ง',
            'Device Status': 'สถานะอุปกรณ์',
            'Basic Information': 'ข้อมูลพื้นฐาน',
            'Gateway': 'Gateway',
            'Grid Meter': 'Grid Meter',
            'Load Meter': 'Load Meter',
            'ESS Meter': 'ESS Meter',
            'Total Active Power': 'Total Active Power',
            'Active Power A': 'Active Power A',
            'Active Power B': 'Active Power B',
            'Active Power C': 'Active Power C',
            'Total Reactive Power': 'Total Reactive Power',
            'Reactive Power A': 'Reactive Power A',
            'Reactive Power B': 'Reactive Power B',
            'Reactive Power C': 'Reactive Power C',
            'Total Apparent Power': 'Total Apparent Power',
            'Apparent Power A': 'Apparent Power A',
            'Apparent Power B': 'Apparent Power B',
            'Apparent Power C': 'Apparent Power C',
            'Total Power Factor': 'Total Power Factor',
            'Active Energy Import': 'Active Energy Import',
            'Active Energy Export': 'Active Energy Export',
            'Active Energy Net': 'Active Energy Net',

            'Generator': 'Generator',

            // Photovoltaic Power Station
            'Invertor': 'อินเวอร์เตอร์',
            'Invertor Run State': 'สถานะการทำงาน',
            'Invertor Unknown': 'ไม่ทราบ',
            'Invertor Initializing': 'กำลังเริ่มต้น',
            'Invertor Standby': 'รายการสำรอง',
            'Invertor Shutdown': 'ปิดเครื่อง',
            'Invertor Fault': 'ความผิด',
            'Invertor Running': 'วิ่ง',

            //Advanced Reporting & Knowledge base
            'Created Datetime': 'วันที่สร้าง',
            'File Format': 'รูปแบบไฟล์',
            'File Size': 'ขนาดไฟล์',
            Uploader: 'ผู้อัปโหลด',
            //Error
            "The page you're looking for is not found": 'ไม่พบหน้าเว็บที่คุณกําลังมองหา',
            "Make sure the address is correct and that the page hasn't moved. ":
                'ตรวจสอบให้แน่ใจว่าที่อยู่ถูกต้องและหน้าเว็บไม่ได้ย้าย. ',
            'If you think this is a mistake,': 'หากคุณคิดว่านี่เป็นความผิดพลาด,',
            'contact us': 'ติดต่อเรา',
            'Take me home': 'พาฉันกลับบ้าน',
            'Whoops, something went wrong!': 'โอ้โหมีบางอย่างผิดพลาด!',
            'Try refreshing the page, or going back and attempting the action again. ':
                'ลองรีเฟรชหน้าเว็บ หรือย้อนกลับไปลองดําเนินการอีกครั้ง. ',
            'If this problem persists,': 'หากปัญหานี้ยังคงมีอยู่,',
            'Captcha Error': 'ข้อผิดพลาด Captcha',
            'Confirm Password Error': 'รหัสผ่านยืนยันไม่ตรงกัน',
            'It looks like you clicked on an invalid password reset link. Please tryagain.':
                'ดูเหมือนว่าคุณคลิกที่ลิงก์รีเซ็ตรหัสผ่านไม่ถูกต้อง กรุณาลองอีกครั้ง',
            'It looks like you clicked on an invalid registration account link. Please tryagain.':
                'ดูเหมือนว่าคุณคลิกที่ลิงค์บัญชีการลงทะเบียนที่ไม่ถูกต้อง กรุณาลองอีกครั้ง',
            //Tenant Bill
            'Lease Contract Number': 'เลขที่สัญญาเช่า',
            Download: 'ดาวน์โหลด',
            Print: 'พิมพ์',
            'Payment Notice': 'แจ้งการชําระเงิน',
            'Bill To': 'เรียกเก็บเงินไปยัง',
            'Bill Number': 'หมายเลขบิล',
            'Bill Date': 'วันที่เรียกเก็บเงิน',
            'Payment Due Date': 'วันครบกําหนดชําระเงิน',
            'Amount Payable': 'จํานวนเงินที่ต้องชําระ',
            'Billing Period Start': 'เริ่มรอบการเรียกเก็บเงิน',
            'Billing Period End': 'สิ้นสุดรอบการเรียกเก็บเงิน',
            Quantity: 'ปริมาณ',
            Price: 'ราคา',
            Unit: 'หน่วย',
            Amount: 'ปริมาณ',
            Subtotal: 'ยอดรวม',
            'VAT Output Tax': 'ภาษีส่งออก VAT',
            'Total Amount Payable': 'ยอดรวมที่ต้องชําระ',
            'Please make sure to pay on or before the payment due date above':
                'โปรดตรวจสอบให้แน่ใจว่าได้ชําระเงินก่อนหรือก่อนวันครบกําหนดชําระเงินข้างต้น',
            'Send money to the following account': 'ส่งเงินเข้าบัญชีต่อไปนี้',
            'Account Name': 'ชื่อบัญชี',
            'Bank Name': 'ชื่อธนาคาร',
            'Bank Address': 'ที่อยู่ธนาคาร',
            'RMB Account': 'บัญชี RMB',
            // button
            'Toggle Navigation': 'สลับการนําทาง',
            // working calendar
            'Working Days': 'วันทําการ',
            'Non Working Days': 'วันที่ไม่ได้ทํางาน',
            'Select Row': 'กรุณาเลือกแถวข้อมูล',
            // Offline Meter Input
            'Daily Value': 'ปริมาณที่แนะนําต่อวัน',
            Date: 'วันที่',
            'Successfully Saved': 'บันทึกสําเร็จ',
            'Previous Data Is Empty': 'ข้อมูลก่อนหน้าว่างเปล่า',
            // API
            'API.ACCOUNT_UNLOCK_FAILED': 'Account unlock failed',
            'API.ADMINISTRATOR_SESSION_NOT_FOUND': 'Administrator session not found',
            'API.ADMINISTRATOR_SESSION_TIMEOUT': 'Administrator session timeout',
            'API.ADVANCED_REPORT_NOT_FOUND': 'Advanced report not found',
            'API.API_KEY_HAS_EXPIRED': 'Key has expired',
            'API.API_KEY_NAME_IS_ALREADY_IN_USE': 'Key name is already in use',
            'API.API_KEY_NOT_FOUND': 'Key not found',
            'API.BAD_REQUEST': 'Bad request',
            'API.BALANCING_PRICE_POINT_NOT_FOUND': 'Balancing price point not found',
            'API.BATTERY_STATE_POINT_NOT_FOUND': 'Battery state point not found',
            'API.BUY_METER_NOT_FOUND': 'Buy meter not found',
            'API.CANNOT_SET_EXISTING_SUBMETER_AS_MASTER_METER': 'Cannot set existing submeter as master meter',
            'API.CHARGE_METER_NOT_FOUND': 'Charge meter not found',
            'API.COMBINED_EQUIPMENT_COMMAND_RELATION_EXISTS': 'Combined equipment command relation exists',
            'API.COMBINED_EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Combined equipment command relation not found',
            'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_EXISTS': 'Combined equipment equipment relation exists',
            'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_NOT_FOUND': 'Combined equipment equipment relation not found',
            'API.COMBINED_EQUIPMENT_METER_RELATION_EXISTS': 'Combined equipment meter relation exists',
            'API.COMBINED_EQUIPMENT_METER_RELATION_NOT_FOUND': 'Combined equipment meter relation not found',
            'API.COMBINED_EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Combined equipment name is already in use',
            'API.COMBINED_EQUIPMENT_NOT_FOUND': 'Combined equipment not found',
            'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Combined equipment offline meter relation exists',
            'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Combined equipment offline meter relation not found',
            'API.COMBINED_EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Combined equipment parameter name is already in use',
            'API.COMBINED_EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Combined equipment parameter not found or not match',
            'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Combined equipment virtual meter relation exists',
            'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Combined equipment virtual meter relation not found',
            'API.COMMAND_NAME_IS_ALREADY_IN_USE': 'Command name is already in use',
            'API.COMMAND_NOT_FOUND': 'Command not  found',
            'API.CONTACT_NAME_IS_ALREADY_IN_USE': 'Contact name is already in use',
            'API.CONTACT_NOT_FOUND': 'Contact not found',
            'API.COOLING_METER_NOT_FOUND': 'Cooling meter not found',
            'API.COST_CENTER_EXTERNAL_ID_EXISTS': 'Cost center external id exists',
            'API.COST_CENTER_NAME_EXISTS': 'Cost center name exists',
            'API.COST_CENTER_NOT_FOUND': 'Cost center not found',
            'API.COST_FILE_NOT_FOUND': 'Cost file not found',
            'API.DATA_REPAIR_FILE_NOT_FOUND': 'Data repair file not found',
            'API.DATA_SOURCE_NAME_IS_ALREADY_IN_USE': 'Data source name is already in use',
            'API.DATA_SOURCE_NOT_FOUND': 'Data source not found',
            'API.DATABASE_ERROR': 'Database error',
            'API.DATE_IS_ALREADY_IN_WORKING_CALENDAR': 'Date Is Already In Working Calendar',
            'API.DATE_LOCAL_NOT_FOUND': 'Date local not found',
            'API.DISCHARGE_METER_NOT_FOUND': 'Discharge meter not found',
            'API.DISTRIBUTION_CIRCUIT_NAME_IS_ALREADY_IN_USE': 'Distribution circuit name is already in use',
            'API.DISTRIBUTION_CIRCUIT_NOT_FOUND': 'Distribution circuit not found',
            'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_EXISTS': 'Distribution circuit point relation exists',
            'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_NOT_FOUND': 'Distribution circuit point relation not found',
            'API.DISTRIBUTION_SYSTEM_NAME_IS_ALREADY_IN_USE': 'Distribution system name is already in use',
            'API.DISTRIBUTION_SYSTEM_NOT_FOUND': 'Distribution system not found',
            'API.ELECTRICITY_METER_NOT_FOUND': 'Electricity meter not found',
            'API.EMAIL_IS_ALREADY_IN_USE': 'Email is already in use',
            'API.EMAIL_MESSAGE_NOT_FOUND': 'Email message not found',
            'API.EMAIL_NOT_FOUND': 'Email not found',
            'API.EMAIL_SERVER_HOST_IS_ALREADY_IN_USE': 'Email server host is already in use',
            'API.EMAIL_SERVER_NOT_FOUND': 'Email server not found',
            'API.EMPTY_VARIABLES_ARRAY': 'Empty variables array',
            'API.ENERGY_CATEGORY_NAME_IS_ALREADY_IN_USE': 'Energy category name is already in use',
            'API.ENERGY_CATEGORY_NOT_FOUND': 'Energy category not found',
            'API.ENERGY_CATEGORY_USED_IN_ENERGY_ITEMS': 'Energy category used in energy items',
            'API.ENERGY_CATEGORY_USED_IN_METER': 'Energy category used in meter',
            'API.ENERGY_CATEGORY_USED_IN_OFFLINE_METER': 'Energy category used in offline meter',
            'API.ENERGY_CATEGORY_USED_IN_TARIFFS': 'Energy category used in tariffs',
            'API.ENERGY_CATEGORY_USED_IN_VIRTUAL_METER': 'Energy category used in virtual meter',
            'API.ENERGY_FLOW_DIAGRAM_LINK_IS_ALREADY_IN_USE': 'Energy flow diagram link is already in use',
            'API.ENERGY_FLOW_DIAGRAM_LINK_NOT_FOUND_OR_NOT_MATCH': 'Energy flow diagram link not found or not match',
            'API.ENERGY_FLOW_DIAGRAM_NAME_IS_ALREADY_IN_USE': 'Energy flow diagram name is already in use',
            'API.ENERGY_FLOW_DIAGRAM_NODE_NAME_IS_ALREADY_IN_USE': 'Energy flow diagram node name is already in use',
            'API.ENERGY_FLOW_DIAGRAM_NODE_NOT_FOUND_OR_NOT_MATCH': 'Energy flow diagram node not found or not match',
            'API.ENERGY_FLOW_DIAGRAM_NOT_FOUND': 'Energy flow diagram not found',
            'API.ENERGY_ITEM_DOES_NOT_BELONG_TO_ENERGY_CATEGORY': 'Energy item does not belong to energy category',
            'API.ENERGY_ITEM_IS_NOT_BELONG_TO_ENERGY_CATEGORY': 'Energy item is not belong to energy category',
            'API.ENERGY_ITEM_NAME_IS_ALREADY_IN_USE': 'Energy item name is already in use',
            'API.ENERGY_ITEM_NOT_FOUND': 'Energy item not found',
            'API.ENERGY_ITEM_USED_IN_METER': 'Energy item used in meter',
            'API.ENERGY_ITEM_USED_IN_OFFLINE_METER': 'Energy item used in offline meter',
            'API.ENERGY_ITEM_USED_IN_VIRTUAL_METER': 'Energy item used in virtual meter',
            'API.ENERGY_STORAGE_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Energy storage power station name is already in use',
            'API.ENERGY_STORAGE_POWER_STATION_NOT_FOUND': 'Energy storage power station not found',
            'API.EQUIPMENT_COMMAND_RELATION_EXISTS': 'Equipment command relation exists',
            'API.EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Equipment command relation not found',
            'API.EQUIPMENT_METER_RELATION_EXISTS': 'Equipment meter relation exists',
            'API.EQUIPMENT_METER_RELATION_NOT_FOUND': 'Equipment meter relation not found',
            'API.EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Equipment name is already in use',
            'API.EQUIPMENT_NOT_FOUND': 'Equipment not found',
            'API.EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Equipment offline meter relation exists',
            'API.EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Equipment offline meter relation not found',
            'API.EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Equipment parameter name is already in use',
            'API.EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Equipment parameter not found or not match',
            'API.EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Equipment virtual meter relation exists',
            'API.EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Equipment virtual meter relation not found',
            'API.ERROR': 'Error',
            'API.EXCEPTION': 'Exception',
            'API.FAILED_TO_READ_REQUEST_STREAM': 'Failed to read request stream',
            'API.FAILED_TO_RESTORE_COST_FILE': 'Failed to restore cost file',
            'API.FAILED_TO_RESTORE_DATA_REPAIR_FILE': 'Failed to restore data repair file',
            'API.FAILED_TO_RESTORE_KNOWLEDGE_FILE': 'Failed to restore knowledge file',
            'API.FAILED_TO_RESTORE_OFFLINE_METER_FILE': 'Failed to restore offline meter file',
            'API.FAILED_TO_SAVE_OFFLINE_METER_FILE': 'Failed to save offline meter file',
            'API.FAILED_TO_UPLOAD_ATTACHMENT_FILE': 'Failed to upload attachment file',
            'API.FAILED_TO_UPLOAD_COST_FILE': 'Failed to upload cost file',
            'API.FAILED_TO_UPLOAD_DATA_REPAIR_FILE': 'Failed to upload data repair file',
            'API.FAILED_TO_UPLOAD_KNOWLEDGE_FILE': 'Failed to upload knowledge file',
            'API.FAILED_TO_UPLOAD_OFFLINE_METER_FILE': 'Failed to upload offline meter file',
            'API.GATEWAY_NAME_IS_ALREADY_IN_USE': 'Gateway name is already in use',
            'API.GATEWAY_NOT_FOUND': 'Gateway not found',
            'API.HEAT_METER_NOT_FOUND': 'Heat meter not found',
            'API.INVALID_': 'Invalid ',
            'API.INVALID_ACKNOWLEDGE_CODE': 'Invalid acknowledge code',
            'API.INVALID_ADDRESS': 'Invalid address',
            'API.INVALID_ADDRESS_VALUE': 'Invalid address value',
            'API.INVALID_ADVANCED_REPORT_ID': 'Invalid advanced report id',
            'API.INVALID_API_KEY_ID': 'Invalid api key id',
            'API.INVALID_API_KEY_NAME': 'Invalid api key name',
            'API.INVALID_AREA_VALUE': 'Invalid area value',
            'API.INVALID_BALANCING_PRICE_POINT_ID': 'Invalid balancing price point ID',
            'API.INVALID_BASE_PERIOD_END_DATETIME': 'Invalid base period end datetime',
            'API.INVALID_BASE_PERIOD_START_DATETIME': 'Invalid base period start datetime',
            'API.INVALID_BATTERY_STATE_POINT_ID': 'Invalid battery state point ID',
            'API.INVALID_BAUD_RATE': 'Invalid baud rate',
            'API.INVALID_BUILDINGS_VALUE': 'Invalid buildings value',
            'API.INVALID_BUY_METER_ID': 'Invalid buy meter id',
            'API.INVALID_CAPACITY': 'Invalid capacity',
            'API.INVALID_CATEGORY': 'Invalid category',
            'API.INVALID_CHANNEL': 'Invalid channel',
            'API.INVALID_CHARGE_METER_ID': 'Invalid charge meter id',
            'API.INVALID_COMBINED_EQUIPMENT_ID': 'Invalid combined equipment id',
            'API.INVALID_COMBINED_EQUIPMENT_NAME': 'Invalid combined equipment name',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_ID': 'Invalid combined equipment parameter id',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_NAME': 'Invalid combined equipment parameter name',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_TYPE': 'Invalid combined equipment parameter type',
            'API.INVALID_COMBINED_EQUIPMENT_UUID': 'Invalid combined equipment uuid',
            'API.INVALID_COMMAND_ID': 'Invalid command id',
            'API.INVALID_COMMAND_NAME': 'Invalid command name',
            'API.INVALID_CONNECTION': 'Invalid connection',
            'API.INVALID_CONSTANT_VALUE': 'Invalid constant value',
            'API.INVALID_CONTACT_ID': 'Invalid contact id',
            'API.INVALID_CONTACT_NAME': 'Invalid contact name',
            'API.INVALID_COOLING_METER_ID': 'Invalid cooling meter id',
            'API.INVALID_COST_CENTER_ID': 'Invalid cost center id',
            'API.INVALID_COST_FILE_ID': 'Invalid cost file id',
            'API.INVALID_CREATED_DATETIME': 'Invalid created datetime',
            'API.INVALID_DATA_REPAIR_FILE_ID': 'Invalid data repair file id',
            'API.INVALID_DATA_SOURCE_ID': 'Invalid data source id',
            'API.INVALID_DATA_SOURCE_NAME': 'Invalid data source name',
            'API.INVALID_DATA_SOURCE_PROTOCOL': 'Invalid data source protocol',
            'API.INVALID_DATE_LOCAL': 'Invalid date local',
            'API.INVALID_DENOMINATOR_METER_UUID': 'Invalid denominator meter uuid',
            'API.INVALID_DISCHARGE_METER_ID': 'Invalid discharge meter id',
            'API.INVALID_DISPLAY_NAME': 'Invalid display name',
            'API.INVALID_DISTRIBUTION_CIRCUIT_ID': 'Invalid distribution circuit id',
            'API.INVALID_DISTRIBUTION_CIRCUIT_NAME': 'Invalid distribution circuit name',
            'API.INVALID_DISTRIBUTION_ROOM': 'Invalid distribution room',
            'API.INVALID_DISTRIBUTION_SYSTEM_ID': 'Invalid distribution system id',
            'API.INVALID_DISTRIBUTION_SYSTEM_NAME': 'Invalid distribution system name',
            'API.INVALID_ELECTRICITY_METER_ID': 'Invalid Electricity meter id',
            'API.INVALID_EMAIL': 'Invalid email',
            'API.INVALID_EMAIL_MESSAGE_ID': 'Invalid email message id',
            'API.INVALID_EMAIL_SERVER_HOST': 'Invalid email server host',
            'API.INVALID_EMAIL_SERVER_ID': 'Invalid email server id',
            'API.INVALID_END_DATE_FORMAT': 'Invalid end date format',
            'API.INVALID_END_DATETIME': 'Invalid end datetime',
            'API.INVALID_ENERGY_CATEGORY_ID': 'Invalid energy category id',
            'API.INVALID_ENERGY_CATEGORY_NAME': 'Invalid energy category name',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_ID': 'Invalid energy flow diagram id',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_LINK_ID': 'Invalid energy flow diagram link id',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NAME': 'Invalid energy flow diagram name',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_ID': 'Invalid energy flow diagram node id',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_NAME': 'Invalid energy flow diagram node name',
            'API.INVALID_ENERGY_ITEM_ID': 'Invalid energy item id',
            'API.INVALID_ENERGY_ITEM_NAME': 'Invalid energy item name',
            'API.INVALID_ENERGY_STORAGE_POWER_STATION_ID': 'Invalid energy storage power station ID',
            'API.INVALID_ENERGY_STORAGE_POWER_STATION_NAME': 'Invalid energy storage power station name',
            'API.INVALID_EQUATION_IN_EXPRESSION': 'Invalid equation in expression',
            'API.INVALID_EQUIPMENT_ID': 'Invalid equipment id',
            'API.INVALID_EQUIPMENT_NAME': 'Invalid equipment name',
            'API.INVALID_EQUIPMENT_PARAMETER_ID': 'Invalid equipment parameter id',
            'API.INVALID_EQUIPMENT_PARAMETER_NAME': 'Invalid equipment parameter name',
            'API.INVALID_EQUIPMENT_PARAMETER_TYPE': 'Invalid equipment parameter type',
            'API.INVALID_EQUIPMENT_UUID': 'Invalid equipment uuid',
            'API.INVALID_EXPIRES_DATETIME': 'Invalid expires datetime',
            'API.INVALID_EXPRESSION': 'Invalid expression',
            'API.INVALID_EXPRESSION_OBJECT': 'Invalid expression object',
            'API.INVALID_FDD_CODE': 'Invalid fdd code',
            'API.INVALID_FLOORS_VALUE': 'Invalid floors value',
            'API.INVALID_FROM_ADDR': 'Invalid from addr',
            'API.INVALID_GATEWAY_ID': 'Invalid gateway id',
            'API.INVALID_GATEWAY_NAME': 'Invalid gateway name',
            'API.INVALID_HEAT_METER_ID': 'Invalid heat meter id',
            'API.INVALID_HIGH_LIMIT_VALUE': 'Invalid high limit value',
            'API.INVALID_HOURLY_HIGH_LIMIT_VALUE': 'Invalid hourly high limit value',
            'API.INVALID_HOURLY_LOW_LIMIT_VALUE': 'Invalid hourly low limit value',
            'API.INVALID_Id': 'Invalid id',
            'API.INVALID_IS_ADMIN_VALUE': 'Invalid is admin value',
            'API.INVALID_IS_COST_DATA_DISPLAYED': 'Invalid is cost data displayed',
            'API.INVALID_IS_COUNTED_VALUE': 'Invalid is counted value',
            'API.INVALID_IS_ENABLED': 'Invalid is enabled',
            'API.INVALID_IS_HIDDEN': 'Invalid is hidden',
            'API.INVALID_IS_IN_LEASE_VALUE': 'Invalid is in lease value',
            'API.INVALID_IS_INPUT_COUNTED_VALUE': 'Invalid is input counted value',
            'API.INVALID_IS_KEY_TENANT_VALUE': 'Invalid is key tenant value',
            'API.INVALID_IS_OUTPUT_COUNTED_VALUE': 'Invalid is output counted value',
            'API.INVALID_IS_OUTPUT_VALUE': 'Invalid is output value',
            'API.INVALID_IS_READ_ONLY_VALUE': 'Invalid is read only value',
            'API.INVALID_IS_TREND_VALUE': 'Invalid is trend value',
            'API.INVALID_IS_VIRTUAL_VALUE': 'Invalid is virtual value',
            'API.INVALID_KGCE': 'Invalid kgce',
            'API.INVALID_KGCO2E': 'Invalid kgco2e',
            'API.INVALID_KNOWLEDGE_FILE_ID': 'Invalid knowledge file id',
            'API.INVALID_LATITUDE_VALUE': 'Invalid latitude value',
            'API.INVALID_LEASE_NUMBER_VALUE': 'Invalid lease number value',
            'API.INVALID_LONGITUDE_VALUE': 'Invalid longitude value',
            'API.INVALID_LOW_LIMIT_VALUE': 'Invalid low limit value',
            'API.INVALID_MASTER_METER_ID': 'Invalid master meter id',
            'API.INVALID_MENU_ID': 'Invalid menu id',
            'API.INVALID_MESSAGE_DATA': 'Invalid message data',
            'API.INVALID_MESSAGE_TEMPLATE': 'Invalid message template',
            'API.INVALID_MESSAGE_TEMPLATE_ID': 'Invalid message template id',
            'API.INVALID_MESSAGE_VALUE': 'Invalid message value',
            'API.INVALID_METER_ID': 'Invalid meter id',
            'API.INVALID_METER_NAME': 'Invalid meter name',
            'API.INVALID_METER_UUID': 'Invalid meter uuid',
            'API.INVALID_MICROGRID_BATTERY_ID': 'Invalid microgrid battery id',
            'API.INVALID_MICROGRID_BATTERY_NAME': 'Invalid microgrid battery name',
            'API.INVALID_MICROGRID_EVCHARGER_ID': 'Invalid microgrid evcharger id',
            'API.INVALID_MICROGRID_EVCHARGER_NAME': 'Invalid microgrid evcharger name',
            'API.INVALID_MICROGRID_GENERATOR_ID': 'Invalid microgrid generator id',
            'API.INVALID_MICROGRID_GENERATOR_NAME': 'Invalid microgrid generator name',
            'API.INVALID_MICROGRID_GRID_ID': 'Invalid microgrid grid id',
            'API.INVALID_MICROGRID_GRID_NAME': 'Invalid microgrid grid name',
            'API.INVALID_MICROGRID_HEATPUMP_ID': 'Invalid microgrid heatpump id',
            'API.INVALID_MICROGRID_HEATPUMP_NAME': 'Invalid microgrid heatpump name',
            'API.INVALID_MICROGRID_ID': 'Invalid microgrid id',
            'API.INVALID_MICROGRID_LOAD_ID': 'Invalid microgrid load id',
            'API.INVALID_MICROGRID_LOAD_NAME': 'Invalid microgrid load name',
            'API.INVALID_MICROGRID_NAME': 'Invalid microgrid name',
            'API.INVALID_MICROGRID_PHOTOVOLTAIC_ID': 'Invalid microgrid photovoltaic ID',
            'API.INVALID_MICROGRID_PHOTOVOLTAIC_NAME': 'Invalid microgrid photovoltaic name',
            'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_ID': 'Invalid microgrid power conversion system ID',
            'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_NAME': 'Invalid microgrid microgrid power conversion system name',
            'API.INVALID_MICROGRID_UUID': 'Invalid microgrid UUID',
            'API.INVALID_NAME_VALUE': 'Invalid name value',
            'API.INVALID_NEW_PASSWORD': 'Invalid new password',
            'API.INVALID_NON_WORKING_DAY_ID': 'Invalid non working day ID',
            'API.INVALID_NOTIFICATION_ID': 'Invalid notification id',
            'API.INVALID_NUMERATOR_METER_UUID': 'Invalid numerator meter uuid',
            'API.INVALID_OBJECT_TYPE': 'Invalid object type',
            'API.INVALID_OFFLINE_METER_DATA': 'Invalid offline meter data',
            'API.INVALID_OFFLINE_METER_FILE_ID': 'Invalid offline meter file id',
            'API.INVALID_OFFLINE_METER_ID': 'Invalid offline meter id',
            'API.INVALID_OFFLINE_METER_NAME': 'Invalid offline meter name',
            'API.INVALID_OFFLINE_METER_UUID': 'Invalid offline meter uuid',
            'API.INVALID_OFFSET_CONSTANT_VALUE': 'Invalid offset constant value',
            'API.INVALID_OLD_PASSWORD': 'Invalid old password',
            'API.INVALID_OPENID': 'Invalid openid',
            'API.INVALID_PARENT_SPACE_ID': 'Invalid parent space id',
            'API.INVALID_PASSWORD': 'Invalid password',
            'API.INVALID_PAYLOAD': 'Invalid payload',
            'API.INVALID_PEAK_CURRENT': 'Invalid peak current',
            'API.INVALID_PEAK_LOAD': 'Invalid peak load',
            'API.INVALID_PERIOD_TYPE': 'Invalid period type',
            'API.INVALID_PHOTOVOLTAIC_POWER_STATION_ID': 'Invalid photovoltaic power station ID',
            'API.INVALID_PHOTOVOLTAIC_POWER_STATION_NAME': 'Invalid photovoltaic power station name',
            'API.INVALID_POINT_ID': 'Invalid point id',
            'API.INVALID_POINT_NAME': 'Invalid point name',
            'API.INVALID_PORT': 'Invalid port',
            'API.INVALID_POSTAL_CODE_VALUE': 'Invalid postal code value',
            'API.INVALID_POWER_POINT_ID': 'Invalid power point id',
            'API.INVALID_PRIORITY': 'Invalid priority',
            'API.INVALID_PRIVILEGE': 'Invalid privilege',
            'API.INVALID_PRIVILEGE_DATA': 'Invalid privilege data',
            'API.INVALID_PRIVILEGE_ID': 'Invalid privilege id',
            'API.INVALID_PRIVILEGE_NAME': 'Invalid privilege name',
            'API.INVALID_RATIO_VALUE': 'Invalid ratio value',
            'API.INVALID_RECIPIENT_EMAIL': 'Invalid recipient email',
            'API.INVALID_RECIPIENT_MOBILE': 'Invalid recipient mobile',
            'API.INVALID_RECIPIENT_NAME': 'Invalid recipient name',
            'API.INVALID_RECIPIENT_OPENID': 'Invalid recipient openid',
            'API.INVALID_REPLY': 'Invalid reply',
            'API.INVALID_REPORTING_PERIOD_END_DATETIME': 'Invalid reporting period end datetime',
            'API.INVALID_REPORTING_PERIOD_START_DATETIME': 'Invalid reporting period start datetime',
            'API.INVALID_REQUIRES_AUTHENTICATION': 'Invalid requires authentication',
            'API.INVALID_ROOMS_VALUE': 'Invalid rooms value',
            'API.INVALID_RULE_ID': 'Invalid rule id',
            'API.INVALID_RULE_NAME': 'Invalid rule name',
            'API.INVALID_RUN_STATE_POINT_ID': 'Invalid run state point ID',
            'API.INVALID_SCHEDULED_DATETIME': 'Invalid scheduled datetime',
            'API.INVALID_SELL_METER_ID': 'Invalid sell meter id',
            'API.INVALID_SENSOR_ID': 'Invalid sensor id',
            'API.INVALID_SENSOR_NAME': 'Invalid sensor name',
            'API.INVALID_SENSOR_UUID': 'Invalid sensor uuid',
            'API.INVALID_SERIAL_NUMBER': 'Invalid serial number',
            'API.INVALID_SERIAL_PORT': 'Invalid serial port',
            'API.INVALID_SESSION_PLEASE_RE_LOGIN': 'Invalid session please re-login',
            'API.INVALID_SET_VALUE': 'Invalid set value',
            'API.INVALID_SHOPFLOOR_ID': 'Invalid shopfloor id',
            'API.INVALID_SHOPFLOOR_NAME': 'Invalid shopfloor name',
            'API.INVALID_SHOPFLOOR_UUID': 'Invalid shopfloor uuid',
            'API.INVALID_SOURCE_NODE_ID': 'Invalid source node id',
            'API.INVALID_SPACE_ID': 'Invalid space id',
            'API.INVALID_SPACE_NAME': 'Invalid space name',
            'API.INVALID_SPACE_UUID': 'Invalid space uuid',
            'API.INVALID_START_DATE_FORMAT': 'Invalid start date format',
            'API.INVALID_START_DATETIME': 'Invalid start datetime',
            'API.INVALID_STATUS': 'Invalid status',
            'API.INVALID_STORE_ID': 'Invalid store id',
            'API.INVALID_STORE_NAME': 'Invalid store name',
            'API.INVALID_STORE_TYPE_DESCRIPTION': 'Invalid store type description',
            'API.INVALID_STORE_TYPE_ID': 'Invalid store type id',
            'API.INVALID_STORE_TYPE_NAME': 'Invalid store type name',
            'API.INVALID_STORE_TYPE_SIMPLIFIED_CODE': 'Invalid store type simplified code',
            'API.INVALID_STORE_UUID': 'Invalid store uuid',
            'API.INVALID_SUBJECT_VALUE': 'Invalid subject value',
            'API.INVALID_SVG': 'Invalid SVG',
            'API.INVALID_SWITCHGEAR': 'Invalid switchgear',
            'API.INVALID_TARGET_NODE_ID': 'Invalid target node id',
            'API.INVALID_TARIFF_BLOCK_PRICING': 'Invalid tariff block pricing',
            'API.INVALID_TARIFF_ID': 'Invalid tariff id',
            'API.INVALID_TARIFF_TIME_OF_USE_PRICING': 'Invalid tariff time of use pricing',
            'API.INVALID_TARIFF_TYPE': 'Invalid tariff type',
            'API.INVALID_TENANT_ID': 'Invalid tenant id',
            'API.INVALID_TENANT_NAME': 'Invalid tenant name',
            'API.INVALID_TENANT_TYPE_DESCRIPTION': 'Invalid tenant type description',
            'API.INVALID_TENANT_TYPE_ID': 'Invalid tenant type id',
            'API.INVALID_TENANT_TYPE_NAME': 'Invalid tenant type name',
            'API.INVALID_TENANT_TYPE_SIMPLIFIED_CODE': 'Invalid tenant type simplified code',
            'API.INVALID_TENANT_UUID': 'Invalid tenant uuid',
            'API.INVALID_TEXT_MESSAGE_ID': 'Invalid text message id',
            'API.INVALID_TIMEZONE_ID': 'Invalid timezone id',
            'API.INVALID_TOKEN': 'Invalid token',
            'API.INVALID_TOPIC': 'Invalid topic',
            'API.INVALID_UNIT_OF_MEASURE': 'Invalid unit of measure',
            'API.INVALID_UNIT_OF_PRICE': 'Invalid unit of price',
            'API.INVALID_UNITS': 'Invalid units',
            'API.INVALID_USER_ID': 'Invalid user id',
            'API.INVALID_USER_NAME': 'Invalid user name',
            'API.INVALID_USER_NAME_OR_EMAIL': 'Invalid user name or email',
            'API.INVALID_USER_PHONE': 'Invalid user phone',
            'API.INVALID_USER_PLEASE_RE_LOGIN': 'Invalid user please re-login',
            'API.INVALID_USER_UUID': 'Invalid user uuid',
            'API.INVALID_USERNAME': 'Invalid userName',
            'API.INVALID_VARIABLE_METER_ID': 'Invalid variable meter id',
            'API.INVALID_VARIABLE_METER_TYPE': 'Invalid variable meter type',
            'API.INVALID_VARIABLE_NAME': 'Invalid variable name',
            'API.INVALID_VERIFICATION_CODE': 'Invalid verification code',
            'API.INVALID_VIRTUAL_METER_ID': 'Invalid virtual meter id',
            'API.INVALID_VIRTUAL_METER_NAME': 'Invalid virtual meter name',
            'API.INVALID_VIRTUAL_METER_UUID': 'Invalid virtual meter uuid',
            'API.INVALID_WEB_MESSAGE_ID': 'Invalid web message id',
            'API.INVALID_WECHAT_MESSAGE_ID': 'Invalid wechat message id',
            'API.INVALID_WIND_FARM_ID': 'Invalid wind farm ID',
            'API.INVALID_WIND_FARM_NAME': 'Invalid wind farm name',
            'API.INVALID_WORKING_CALENDAR_ID': 'Invalid working calendar id ',
            'API.INVALID_WORKING_CALENDAR_NAME': 'Invalid working calendar name',
            'API.KNOWLEDGE_FILE_CANNOT_BE_REMOVED_FROM_DISK': 'Knowledge File Cannot be Removed from Disk',
            'API.KNOWLEDGE_FILE_NOT_FOUND': 'Knowledge file not found',
            'API.MASTER_METER_DOES_NOT_BELONG_TO_SAME_ENERGY_CATEGORY':
                'Master meter does not belong to same energy category',
            'API.MASTER_METER_NOT_FOUND': 'Master meter not found',
            'API.MENU_NOT_FOUND': 'Menu not found',
            'API.METER_CANNOT_HAVE_MORE_THAN_ONE_ENERGY_VALUE_POINTS': 'Meter cannot have more than one energy value points',
            'API.METER_COMMAND_RELATION_EXISTS': 'Meter command relation exists',
            'API.METER_COMMAND_RELATION_NOT_FOUND': 'Meter command relation not found',
            'API.METER_NAME_IS_ALREADY_IN_USE': 'Meter name is already in use',
            'API.METER_NOT_FOUND': 'Meter not found',
            'API.METER_OF_VARIABLE_NOT_FOUND': 'Meter of variable not found',
            'API.METER_POINT_RELATION_EXISTS': 'Meter point relation exists',
            'API.METER_POINT_RELATION_NOT_FOUND': 'Meter point relation not found',
            'API.MICROGRID_BATTERY_NAME_IS_ALREADY_IN_USE': 'Microgrid battery name is already in use',
            'API.MICROGRID_BATTERY_NOT_FOUND': 'Microgrid battery not found',
            'API.MICROGRID_EVCHARGER_NAME_IS_ALREADY_IN_USE': 'Microgrid evcharger name is already in use',
            'API.MICROGRID_EVCHARGER_NOT_FOUND': 'Microgrid evcharger not fund',
            'API.MICROGRID_GENERATOR_NAME_IS_ALREADY_IN_USE': 'Microgrid generator name is already in use',
            'API.MICROGRID_GENERATOR_NOT_FOUND': 'Microgrid generator not found',
            'API.MICROGRID_GRID_NAME_IS_ALREADY_IN_USE': 'Microgrid grid name is already in use',
            'API.MICROGRID_GRID_NOT_FOUND': 'Microgrid grid not found',
            'API.MICROGRID_HEATPUMP_NAME_IS_ALREADY_IN_USE': 'Microgrid heatpump name is already in use',
            'API.MICROGRID_HEATPUMP_NOT_FOUND': 'Microgrid heatpump not found',
            'API.MICROGRID_LOAD_NAME_IS_ALREADY_IN_USE': 'Microgrid load name is already',
            'API.MICROGRID_LOAD_NOT_FOUND': 'Microgrid load not found',
            'API.MICROGRID_NAME_IS_ALREADY_IN_USE': 'Microgrid name is already in use',
            'API.MICROGRID_NOT_FOUND': 'Microgrid not found',
            'API.MICROGRID_PHOTOVOLTAIC_NAME_IS_ALREADY_IN_USE': 'Microgrid photovoltaic name is already in use',
            'API.MICROGRID_PHOTOVOLTAIC_NOT_FOUND': 'Microgrid photovoltaic not found',
            'API.MICROGRID_POWER_CONVERSION_SYSTEM_NAME_IS_ALREADY_IN_USE':
                'Microgrid power conversion system name is already in use',
            'API.MICROGRID_POWER_CONVERSION_SYSTEM_NOT_FOUND': 'Microgrid power conversion system not found',
            'API.MICROGRID_SENSOR_RELATION_EXISTS': 'Microgrid sensor relation exists',
            'API.MICROGRID_SENSOR_RELATION_NOT_FOUND': 'Microgrid sensor not found',
            'API.MQTT_CONNECTION_ERROR': 'Mqtt connection error',
            'API.MQTT_PUBLISH_ERROR': 'Mqtt publish error',
            'API.NEW_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'New password length cannot exceed 100 characters',
            'API.NEW_USER_SESSION_NOT_FOUND': 'New user session not found',
            'API.NEW_USER_SESSION_TIMEOUT': 'New user session timeout',
            'API.NON_WORKING_DAY_NOT_FOUND': 'Non working day non found',
            'API.NOT_FOUND': 'Not found',
            'API.NOTIFICATION_NOT_FOUND': 'Notification not found',
            'API.OFFLINE_METER_FILE_NOT_FOUND': 'Offline meter file not found',
            'API.OFFLINE_METER_NAME_IS_ALREADY_IN_USE': 'Offline meter name is already in use',
            'API.OFFLINE_METER_NOT_FOUND': 'Offline meter not found',
            'API.INVALID_OFFLINE_METER_VALUE': 'ค่ามิเตอร์ออฟไลน์ไม่ถูกต้อง',
            'API.OFFLINE_METER_OF_VARIABLE_NOT_FOUND': 'Offline meter of variable not found',
            'API.OLD_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Old password length cannot exceed 100 characters',
            'API.PARENT_SPACE_NOT_FOUND': 'Parent space not found',
            'API.PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Password length cannot exceed 100 characters',
            'API.PASSWORDS_MATCH': 'New password is the same as the old password',
            'API.PHOTOVOLTAIC_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Photovoltaic power station name is already in use',
            'API.PHOTOVOLTAIC_POWER_STATION_NOT_FOUND': 'Photovoltaic power station not found',
            'API.POINT_NAME_IS_ALREADY_IN_USE': 'Point name is already in use',
            'API.POINT_NOT_FOUND': 'Point not found',
            'API.POWER_POINT_NOT_FOUND': 'Power point not found',
            'API.PRIVILEGE_NAME_IS_ALREADY_IN_USE': 'Privilege name is already in use',
            'API.PRIVILEGE_NOT_FOUND': 'Privilege not found',
            'API.RULE_NAME_IS_ALREADY_IN_USE': 'Rule name is already in use',
            'API.RULE_NOT_FOUND': 'Rule not found',
            'API.SELL_METER_NOT_FOUND': 'Sell meter not found',
            'API.SENSOR_NAME_IS_ALREADY_IN_USE': 'Sensor name is already in use',
            'API.SENSOR_NOT_FOUND': 'Sensor not found',
            'API.SENSOR_POINT_RELATION_EXISTS': 'Sensor point relation exists',
            'API.SENSOR_POINT_RELATION_NOT_FOUND': 'Sensor point relation not found',
            'API.SHOPFLOOR_COMMAND_RELATION_EXISTS': 'Shopfloor command relation exists',
            'API.SHOPFLOOR_COMMAND_RELATION_NOT_FOUND': 'Shopfloor command relation not found',
            'API.SHOPFLOOR_EQUIPMENT_RELATION_EXISTS': 'Shopfloor equipment relation exists',
            'API.SHOPFLOOR_EQUIPMENT_RELATION_NOT_FOUND': 'Shopfloor equipment relation not found',
            'API.SHOPFLOOR_METER_RELATION_EXISTS': 'Shopfloor meter relation exists',
            'API.SHOPFLOOR_METER_RELATION_NOT_FOUND': 'Shopfloor meter relation not found',
            'API.SHOPFLOOR_NAME_IS_ALREADY_IN_USE': 'Shopfloor name is already in use',
            'API.SHOPFLOOR_NOT_FOUND': 'Shopfloor not found',
            'API.SHOPFLOOR_OFFLINE_METER_RELATION_EXISTS': 'Shopfloor offline meter relation exists',
            'API.SHOPFLOOR_OFFLINE_METER_RELATION_NOT_FOUND': 'Shopfloor offline meter relation not found',
            'API.SHOPFLOOR_POINT_RELATION_EXISTS': 'Shopfloor point relation exists',
            'API.SHOPFLOOR_POINT_RELATION_NOT_FOUND': 'Shopfloor point relation not found',
            'API.SHOPFLOOR_SENSOR_RELATION_EXISTS': 'Shopfloor sensor relation exists',
            'API.SHOPFLOOR_SENSOR_RELATION_NOT_FOUND': 'Shopfloor sensor relation not found',
            'API.SHOPFLOOR_VIRTUAL_METER_RELATION_EXISTS': 'Shopfloor virtual meter relation exists',
            'API.SHOPFLOOR_VIRTUAL_METER_RELATION_NOT_FOUND': 'Shopfloor virtual meter relation not found',
            'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_EXISTS': 'Shopfloor working calendar relation exists',
            'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Shopfloor working calendar relation not found',
            'API.SOC_POINT_NOT_FOUND': 'SOC point not found',
            'API.SOURCE_NODE_NOT_FOUND': 'Source node not found',
            'API.SPACE_COMBINED_EQUIPMENT_RELATION_EXISTS': 'Space combined equipment relation exists',
            'API.SPACE_COMBINED_EQUIPMENT_RELATION_NOT_FOUND': 'Space combined equipment relation not found',
            'API.SPACE_COMMAND_RELATION_EXISTS': 'Space command relation exists',
            'API.SPACE_COMMAND_RELATION_NOT_FOUND': 'Space command relation not found',
            'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_EXISTS': 'Space Energy Storage Power Station Relation Exists',
            'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_NOT_FOUND': 'Space Energy Storage Power Station Relation Not Found',
            'API.SPACE_EQUIPMENT_RELATION_EXISTS': 'Space equipment relation exists',
            'API.SPACE_EQUIPMENT_RELATION_NOT_FOUND': 'Space equipment relation not found',
            'API.SPACE_METER_RELATION_EXISTS': 'Space meter relation exists',
            'API.SPACE_METER_RELATION_NOT_FOUND': 'Space meter relation not found',
            'API.SPACE_NAME_IS_ALREADY_IN_USE': 'Space name is already in use',
            'API.SPACE_NOT_FOUND': 'Space not found',
            'API.SPACE_NOT_FOUND_IN_PRIVILEGE': 'Space not found in privilege',
            'API.SPACE_OFFLINE_METER_RELATION_EXISTS': 'Space offline meter relation exists',
            'API.SPACE_OFFLINE_METER_RELATION_NOT_FOUND': 'Space offline meter relation not found',
            'API.SPACE_POINT_RELATION_EXISTS': 'Space point relation exists',
            'API.SPACE_POINT_RELATION_NOT_FOUND': 'Space point relation not found',
            'API.SPACE_SENSOR_RELATION_EXISTS': 'Space sensor relation exists',
            'API.SPACE_SENSOR_RELATION_NOT_FOUND': 'Space sensor relation not found',
            'API.SPACE_SHOPFLOOR_RELATION_EXISTS': 'Space shopfloor relation exists',
            'API.SPACE_SHOPFLOOR_RELATION_NOT_FOUND': 'Space shopfloor relation not found',
            'API.SPACE_STORE_RELATION_EXISTS': 'Space store relation exists',
            'API.SPACE_STORE_RELATION_NOT_FOUND': 'Space store relation not found',
            'API.SPACE_TENANT_RELATION_EXISTS': 'Space tenant relation exists',
            'API.SPACE_TENANT_RELATION_NOT_FOUND': 'Space tenant relation not found',
            'API.SPACE_VIRTUAL_METER_RELATION_EXISTS': 'Space virtual meter relation exists',
            'API.SPACE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Space virtual meter relation not found',
            'API.SPACE_WORKING_CALENDAR_RELATION_EXISTS': 'Space working calendar relation exists',
            'API.SPACE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Space working calendar relation not found',
            'API.START_DATETIME_MUST_BE_EARLIER_THAN_END_DATETIME': 'Start datetime must be early than end datetime',
            'API.STORE_COMMAND_RELATION_EXISTS': 'Store command relation exists',
            'API.STORE_COMMAND_RELATION_NOT_FOUND': 'Store command relation not found',
            'API.STORE_METER_RELATION_EXISTS': 'Store meter relation exists',
            'API.STORE_METER_RELATION_NOT_FOUND': 'Store meter relation not found',
            'API.STORE_NAME_IS_ALREADY_IN_USE': 'Store name is already in use',
            'API.STORE_NOT_FOUND': 'Store not found',
            'API.STORE_OFFLINE_METER_RELATION_EXISTS': 'Store offline meter relation exists',
            'API.STORE_OFFLINE_METER_RELATION_NOT_FOUND': 'Store offline meter relation not found',
            'API.STORE_POINT_RELATION_EXISTS': 'Store point relation exists',
            'API.STORE_POINT_RELATION_NOT_FOUND': 'Store point relation not found',
            'API.STORE_SENSOR_RELATION_EXISTS': 'Store sensor relation exists',
            'API.STORE_SENSOR_RELATION_NOT_FOUND': 'Store sensor relation not found',
            'API.STORE_TYPE_NAME_IS_ALREADY_IN_USE': 'Store type name is already in use',
            'API.STORE_TYPE_NOT_FOUND': 'Store type not found',
            'API.STORE_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Store type simplified code is already in use',
            'API.STORE_TYPE_USED_IN_STORE': 'Store type used in store',
            'API.STORE_VIRTUAL_METER_RELATION_EXISTS': 'Store virtual meter relation exists',
            'API.STORE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Store virtual meter relation not found',
            'API.STORE_WORKING_CALENDAR_RELATION_EXISTS': 'Store working calendar relation exists',
            'API.STORE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Store working calendar relation not found',
            'API.TARGET_NODE_NOT_FOUND': 'Target node not found',
            'API.TARIFF_IN_USE': 'Tariff in use',
            'API.TARIFF_IS_ALREADY_ASSOCIATED_WITH_COST_CENTER': 'Tariff is already associated with cost center',
            'API.TARIFF_IS_NOT_ASSOCIATED_WITH_COST_CENTER': 'Tariff is not associated with cost center',
            'API.TARIFF_NAME_IS_ALREADY_IN_USE': 'Tariff name is already in use',
            'API.TARIFF_NOT_FOUND': 'Tariff not found',
            'API.TENANT_COMMAND_RELATION_EXISTS': 'Tenant command relation exists',
            'API.TENANT_COMMAND_RELATION_NOT_FOUND': 'Tenant command relation  not found',
            'API.TENANT_METER_RELATION_EXISTS': 'Tenant meter relation exists',
            'API.TENANT_METER_RELATION_NOT_FOUND': 'Tenant meter relation not found',
            'API.TENANT_NAME_IS_ALREADY_IN_USE': 'Tenant name is already in use',
            'API.TENANT_NOT_FOUND': 'Tenant not found',
            'API.TENANT_OFFLINE_METER_RELATION_EXISTS': 'Tenant offline meter relation exists',
            'API.TENANT_OFFLINE_METER_RELATION_NOT_FOUND': 'Tenant offline meter relation not found',
            'API.TENANT_POINT_RELATION_EXISTS': 'Tenant point relation exists',
            'API.TENANT_POINT_RELATION_NOT_FOUND': 'Tenant point relation not found',
            'API.TENANT_SENSOR_RELATION_EXISTS': 'Tenant sensor relation exists',
            'API.TENANT_SENSOR_RELATION_NOT_FOUND': 'Tenant sensor relation not found',
            'API.TENANT_TYPE_NAME_IS_ALREADY_IN_USE': 'Tenant type name is already in use',
            'API.TENANT_TYPE_NOT_FOUND': 'Tenant type not found',
            'API.TENANT_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Tenant type simplified code is already in use',
            'API.TENANT_TYPE_USED_IN_TENANT': 'Tenant type used in tenant',
            'API.TENANT_VIRTUAL_METER_RELATION_EXISTS': 'Tenant virtual meter relation exists',
            'API.TENANT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Tenant virtual meter relation not found',
            'API.TENANT_WORKING_CALENDAR_RELATION_EXISTS': 'Tenant working calendar relation exists',
            'API.TENANT_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Tenant working calendar relation not found',
            'API.TEXT_MESSAGE_NOT_FOUND': 'Text message not found',
            'API.THE_REPORTING_PERIOD_MUST_BE_LONGER_THAN_15_MINUTES': 'The reporting period must be longer than 15 minutes',
            'API.THERE_IS_RELATION_WITH_CHILD_METERS': 'There is relation with child meters',
            'API.THERE_IS_RELATION_WITH_CHILDREN_SPACES': 'There is relation with children spaces',
            'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENT_PARAMETERS':
                'There is relation with combined equipment parameters',
            'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENTS': 'There is relation with combined equipments',
            'API.THERE_IS_RELATION_WITH_DATA_SOURCES': 'There is relation with data sources',
            'API.THERE_IS_RELATION_WITH_ENERGY_FLOW_DIAGRAM_LINKS': 'There is relation with energy flow diagram links',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_BATTERIES': 'There Is Relation With Energy Storage Containers Batteries',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_GRIDS': 'There Is Relation With Energy Storage Containers Grids',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_LOADS': 'There Is Relation With Energy Storage Containers Loads',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_POWER_CONVERSION_SYSTEMS': 'There Is Relation With Energy Storage Containers Power Conversion Systems',
            'API.THERE_IS_RELATION_WITH_EQUIPMENT_PARAMETERS': 'There is relation with equipment parameters',
            'API.THERE_IS_RELATION_WITH_EQUIPMENTS': 'There is relation with equipments',
            'API.THERE_IS_RELATION_WITH_METER': 'There is relation with meter',
            'API.THERE_IS_RELATION_WITH_METERS': 'There is relation with meters',
            'API.THERE_IS_RELATION_WITH_OFFLINE_METER': 'There is relation with offline meter',
            'API.THERE_IS_RELATION_WITH_OFFLINE_METERS': 'There is relation with offline meters',
            'API.THERE_IS_RELATION_WITH_OTHER_VIRTUAL_METERS': 'There is relation with other virtual meters',
            'API.THERE_IS_RELATION_WITH_SENSORS': 'There is relation with sensors',
            'API.THERE_IS_RELATION_WITH_SHOPFLOORS': 'There is relation with shopfloors',
            'API.THERE_IS_RELATION_WITH_SPACES': 'There is relation with spaces',
            'API.THERE_IS_RELATION_WITH_STORES': 'There is relation with stores',
            'API.THERE_IS_RELATION_WITH_TENANTS': 'There is relation with tenants',
            'API.THERE_IS_RELATION_WITH_USERS': 'There is relation with users',
            'API.THERE_IS_RELATION_WITH_VIRTUAL_METER': 'There is relation with virtual meter',
            'API.THERE_IS_RELATION_WITH_VIRTUAL_POWER_PLANTS': 'มีความสัมพันธ์กับโรงไฟฟ้าเสมือนจริง',
            'API.THIS_DATA_SOURCE_IS_BEING_USED_BY_A_METER': 'This data source is being used by a meter',
            'API.THIS_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'This meter is being used by a virtual meter',
            'API.THIS_OFFLINE_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'This offline meter is being used by a virtual meter',
            'API.THIS_SPACE_CANNOT_BE_CLONED': 'This space cannot be cloned',
            'API.THIS_SPACE_CANNOT_BE_DELETED': 'This space cannot be deleted',
            'API.TIMEZONE_NOT_FOUND': 'Timezone not found',
            'API.TOKEN_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'Token not found in headers please login',
            'API.USER_ACCOUNT_HAS_BEEN_LOCKED': 'User Account Has Been Locked',
            'API.USER_ACCOUNT_HAS_EXPIRED': 'User Account Has Expired',
            'API.USER_ACCOUNT_IS_NOT_LOCKED': 'User account is not locked',
            'API.USER_NAME_IS_ALREADY_IN_USE': 'User name is already in use',
            'API.USER_NOT_FOUND': 'User not found',
            'API.USER_PASSWORD_HAS_EXPIRED': 'User Password Has Expired',
            'API.USER_PRIVILEGE_NOT_FOUND': 'User privilege not found',
            'API.USER_SESSION_NOT_FOUND': 'User session not found',
            'API.USER_SESSION_TIMEOUT': 'User session timeout',
            'API.USER_UUID_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'User uuid not found in headers please login',
            'API.VIRTUAL_METER_NAME_IS_ALREADY_IN_USE': 'Virtual meter name is already in use',
            'API.VIRTUAL_METER_NOT_FOUND': 'Virtual meter not found',
            'API.VIRTUAL_METER_OF_VARIABLE_NOT_FOUND': 'Virtual meter of variable not found',
            'API.VIRTUAL_POINT_SHOULD_BE_ANALOG_VALUE': 'Virtual point should be analog value',
            'API.WEB_MESSAGE_NOT_FOUND': 'Web message not found',
            'API.WECHAT_MESSAGE_NOT_FOUND': 'Wechat message not found',
            'API.WIND_FARM_NAME_IS_ALREADY_IN_USE': 'Wind farm name is already in use',
            'API.WIND_FARM_NOT_FOUND': 'Wind farm not found',
            'API.WORKING_CALENDAR_NAME_IS_ALREADY_IN_USE': 'Working calendar name is already in use',
            'API.WORKING_CALENDAR_NOT_FOUND': 'Working calendar not found',

            MasterMeter: 'ตารางรวม',
            SubMeter: 'ตารางแยก',
            'Power Quality': 'Güç kalitesi',
            'About Power Quality': 'Güç kalitesi hakkında',
            Category: 'Kategori',
            Type: 'Tür',
            Limit: 'Sınır',
            'Normal Limit': 'Normal sınır',
            'Severe Limit': 'Ağır sınır',
            Compliance: 'Uyum oranı',
            'Worst Deviation': 'En büyük sapma',
            'Worst Time': 'En kötü zaman',
            'Severe Exceed Count': 'Ağır aşım sayısı',
            'Worst Unbalance': 'Maksimum dengesizlik',
            Hz: 'Hz',
            voltage: 'Gerilim',
            current: 'Akım',
            frequency: 'Frekans',
            voltage_deviation: 'Gerilim sapması',
            current_unbalance: 'Akım dengesizliği',
            voltage_unbalance: 'Gerilim dengesizliği',
            mean_deviation_pct: 'Ortalama sapma (%)',
            p95_abs_deviation_pct: 'P95 mutlak sapma (%)',
            mean_abs_deviation_hz: 'Ortalama mutlak sapma (Hz)',
            p95_abs_deviation_hz: 'P95 mutlak sapma (Hz)',
            mean_unbalance_pct: 'Ortalama dengesizlik (%)',
            p95_unbalance_pct: 'P95 dengesizlik (%)',
            count: 'Adet',
            min: 'Min',
            max: 'Maks',
            mean: 'Ortalama',
            std: 'Std',
            p5: 'P5',
            p95: 'P95'
        }
};
